export function MenuBarSvg({ colors, style }) {
  return (
    <svg
      viewBox="0 0 390 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask id="path-1-inside-1_1901_3346" fill="white">
        <path d="M360 0C376.569 0 390 13.4315 390 30V60H0V30C0 13.4315 13.4315 6.03994e-07 30 0H155C171.5 0 172.909 31 195 31C217.091 31 217.5 0 235 0H360Z" />
      </mask>
      <path
        d="M360 0C376.569 0 390 13.4315 390 30V60H0V30C0 13.4315 13.4315 6.03994e-07 30 0H155C171.5 0 172.909 31 195 31C217.091 31 217.5 0 235 0H360Z"
        fill={colors.background}
      />
      <path
        d="M390 60V61H391V60H390ZM0 60H-1V61H0V60ZM30 0V-1V0ZM360 0V1C376.016 1 389 13.9837 389 30H390H391C391 12.8792 377.121 -1 360 -1V0ZM390 30H389V60H390H391V30H390ZM390 60V59H0V60V61H390V60ZM0 60H1V30H0H-1V60H0ZM0 30H1C1 13.9837 13.9837 1 30 1V0V-1C12.8792 -0.999999 -1 12.8792 -1 30H0ZM30 0V1H155V0V-1H30V0ZM155 0V1C158.761 1 161.699 2.74817 164.384 5.53725C167.102 8.36109 169.451 12.1309 172.072 16.0554C177.232 23.7823 183.374 32 195 32V31V30C184.535 30 178.926 22.7177 173.735 14.9446C171.18 11.1191 168.702 7.13891 165.825 4.15025C162.914 1.12683 159.489 -1 155 -1V0ZM195 31V32C206.637 32 212.528 23.7663 217.56 16.046C220.115 12.1252 222.432 8.36007 225.188 5.54321C227.907 2.76544 230.972 1 235 1V0V-1C230.278 -1 226.729 1.10956 223.759 4.14429C220.827 7.13993 218.38 11.1248 215.884 14.954C210.814 22.7337 205.455 30 195 30V31ZM235 0V1H360V0V-1H235V0Z"
        fill={colors.primary}
        mask="url(#path-1-inside-1_1901_3346)"
      />
    </svg>
  );
}

export function HomeIcon({ colors, style }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.57861 16.1357C8.57861 15.7215 8.91439 15.3857 9.32861 15.3857H15.1436C15.5578 15.3857 15.8936 15.7215 15.8936 16.1357C15.8936 16.5499 15.5578 16.8857 15.1436 16.8857H9.32861C8.91439 16.8857 8.57861 16.5499 8.57861 16.1357Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.05976 5.97765C6.64722 6.35978 6.2768 6.68822 5.94753 6.97845C5.90105 7.01941 5.85554 7.05949 5.81095 7.09875C5.53204 7.34435 5.28915 7.55824 5.07098 7.75963C4.56567 8.22608 4.24648 8.57827 4.02075 8.97216C3.56825 9.76176 3.3999 10.869 3.3999 13.713C3.3999 15.7691 3.52297 17.2451 3.80106 18.3153C4.07406 19.3658 4.48102 19.9679 5.02012 20.3548C5.58316 20.759 6.38695 20.9997 7.59735 21.1245C8.80656 21.2491 10.3149 21.25 12.2359 21.25C14.1569 21.25 15.6653 21.2491 16.8745 21.1245C18.0849 20.9997 18.8887 20.759 19.4517 20.3548C19.9908 19.9679 20.3978 19.3658 20.6708 18.3153C20.9489 17.2451 21.0719 15.7691 21.0719 13.713C21.0719 10.8689 20.9038 9.76166 20.4515 8.97204C20.2259 8.57818 19.9068 8.22601 19.4016 7.75958C19.1833 7.55801 18.9402 7.34391 18.661 7.09801C18.6167 7.05898 18.5714 7.01914 18.5252 6.97843C18.196 6.6882 17.8256 6.35976 17.413 5.97762C17.1688 5.78041 16.9158 5.56703 16.6536 5.34588C16.0825 4.86414 15.4676 4.34554 14.8043 3.87695C13.8194 3.18118 12.9274 2.75 12.2079 2.75C11.4908 2.75 10.611 3.18121 9.63903 3.87803C9.00475 4.33278 8.42452 4.827 7.87933 5.29137C7.59766 5.53128 7.32535 5.76323 7.05976 5.97765ZM8.76503 2.65897C9.76536 1.94179 10.9821 1.25 12.2079 1.25C13.4304 1.25 14.657 1.93632 15.6698 2.6518C16.3858 3.15759 17.094 3.75449 17.687 4.25416C17.9399 4.46729 18.1718 4.66274 18.3743 4.82587C18.3879 4.83681 18.4011 4.84822 18.4139 4.86008C18.8199 5.23662 19.1853 5.5607 19.5171 5.85318C19.5621 5.89284 19.6066 5.93205 19.6507 5.97083C19.9286 6.21553 20.1868 6.4429 20.4192 6.65748C20.9584 7.15537 21.4123 7.63157 21.7531 8.22646C22.4335 9.41434 22.5719 10.9261 22.5719 13.713C22.5719 15.8004 22.4501 17.432 22.1226 18.6926C21.7899 19.9727 21.2304 20.9245 20.3264 21.5734C19.4463 22.2051 18.3303 22.4824 17.0283 22.6166C15.7336 22.75 14.1493 22.75 12.2731 22.75H12.1988C10.3225 22.75 8.73821 22.75 7.44355 22.6166C6.14155 22.4824 5.02553 22.2051 4.14543 21.5734C3.24141 20.9245 2.68194 19.9727 2.34928 18.6926C2.02172 17.432 1.8999 15.8004 1.8999 13.713C1.8999 10.926 2.03856 9.41424 2.71931 8.22634C3.06021 7.63148 3.5142 7.1553 4.05355 6.65743C4.28573 6.4431 4.54366 6.216 4.82121 5.97161C4.86555 5.93257 4.91039 5.89309 4.9557 5.85316C5.28752 5.56069 5.6529 5.23661 6.05892 4.86008C6.07174 4.84818 6.08498 4.83674 6.09861 4.82577C6.31073 4.65502 6.55829 4.44454 6.82983 4.21367C7.40382 3.72566 8.08495 3.14655 8.76503 2.65897Z"
        fill={colors.primary}
      />
    </svg>
  );
}

export function WalletIcon({ colors, style }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5345 10.2988C16.5335 10.2988 15.7217 11.1107 15.7217 12.1117C15.7217 13.1138 16.5337 13.9255 17.5345 13.9255H21.4212C21.8354 13.9255 22.1712 14.2613 22.1712 14.6755C22.1712 15.0897 21.8354 15.4255 21.4212 15.4255H17.5345C15.7049 15.4255 14.2217 13.9419 14.2217 12.1117C14.2217 10.2822 15.7051 8.79883 17.5345 8.79883H21.3907C21.8049 8.79883 22.1407 9.13461 22.1407 9.54883C22.1407 9.96304 21.8049 10.2988 21.3907 10.2988H17.5345Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.9248 12.0527C16.9248 11.6385 17.2606 11.3027 17.6748 11.3027H17.972C18.3862 11.3027 18.722 11.6385 18.722 12.0527C18.722 12.4669 18.3862 12.8027 17.972 12.8027H17.6748C17.2606 12.8027 16.9248 12.4669 16.9248 12.0527Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.10596 8.14355C7.10596 7.72933 7.44175 7.39355 7.85596 7.39355H11.916C12.3302 7.39355 12.666 7.72933 12.666 8.14355C12.666 8.55776 12.3302 8.89355 11.916 8.89355H7.85596C7.44175 8.89355 7.10596 8.55776 7.10596 8.14355Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.50549 6.13409C4.29321 7.24706 3.71387 9.10455 3.71387 12.2529C3.71387 15.4008 4.29319 17.2583 5.50552 18.3714C6.7371 19.5022 8.80786 20.042 12.2649 20.042C15.7213 20.042 17.7918 19.5022 19.0233 18.3714C20.2355 17.2583 20.8149 15.4008 20.8149 12.2529C20.8149 9.10455 20.2355 7.24704 19.0233 6.13406C17.7919 5.0034 15.7214 4.46387 12.2649 4.46387C8.8078 4.46387 6.73706 5.00341 5.50549 6.13409ZM4.49106 5.02913C6.16592 3.49148 8.74566 2.96387 12.2649 2.96387C15.7836 2.96387 18.3631 3.49148 20.0378 5.02915C21.7318 6.58451 22.3149 8.99653 22.3149 12.2529C22.3149 15.5089 21.7318 17.9209 20.0378 19.4763C18.3631 21.0141 15.7836 21.542 12.2649 21.542C8.7456 21.542 6.16588 21.0141 4.49103 19.4763C2.79693 17.9209 2.21387 15.5089 2.21387 12.2529C2.21387 8.99653 2.79692 6.58449 4.49106 5.02913Z"
        fill={colors.primary}
      />
    </svg>
  );
}

export function HistoryIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.68 20.991C19.973 20.22 21.5 17.636 21.5 12C21.5 5.063 19.187 2.75 12.25 2.75C5.313 2.75 3 5.063 3 12C3 18.937 5.313 21.25 12.25 21.25"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6405 14.0178L12.2495 11.9948V7.63379"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ProfileIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8445 21.6623C8.15273 21.6623 5 21.0878 5 18.7871C5 16.4863 8.13273 14.3623 11.8445 14.3623C15.5364 14.3623 18.6891 16.4657 18.6891 18.7665C18.6891 21.0663 15.5564 21.6623 11.8445 21.6623Z"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8374 11.1741C14.2602 11.1741 16.2238 9.21039 16.2238 6.78767C16.2238 4.36494 14.2602 2.40039 11.8374 2.40039C9.41476 2.40039 7.45022 4.36494 7.45022 6.78767C7.44204 9.20221 9.39204 11.1659 11.8065 11.1741C11.8174 11.1741 11.8274 11.1741 11.8374 11.1741Z"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function LanguageIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_753_12030)">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z"
          fill={colors.primary}
        />
      </g>
      <defs>
        <clipPath id="clip0_753_12030">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BankListIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7388 6.15344C19.7388 3.40256 17.8581 2.2998 15.1503 2.2998H8.79143C6.16687 2.2998 4.19995 3.32737 4.19995 5.96998V20.6938C4.19995 21.4196 4.9809 21.8767 5.61348 21.5219L11.9954 17.9419L18.3223 21.5158C18.9558 21.8727 19.7388 21.4156 19.7388 20.6888V6.15344Z"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.27124 9.02734H15.5895"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ServiceIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_753_12038)">
        <path
          d="M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18C4.55 18 5 17.55 5 17V12.19C5 8.36 7.95 5.01 11.78 4.9C15.74 4.78 19 7.96 19 11.9V19H12C11.45 19 11 19.45 11 20C11 20.55 11.45 21 12 21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z"
          fill={colors.primary}
        />
        <path
          d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z"
          fill={colors.primary}
        />
        <path
          d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z"
          fill={colors.primary}
        />
        <path
          d="M18 11.03C17.52 8.18 15.04 6 12.05 6C9.01997 6 5.75997 8.51 6.01997 12.45C8.48997 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z"
          fill={colors.primary}
        />
      </g>
      <defs>
        <clipPath id="clip0_753_12038">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AboutIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.2502 12C21.2502 18.937 18.9372 21.25 12.0002 21.25C5.06324 21.25 2.75024 18.937 2.75024 12C2.75024 5.063 5.06324 2.75 12.0002 2.75C18.9372 2.75 21.2502 5.063 21.2502 12Z"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0002 15.895V12"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0046 8.5H11.9956"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function TermIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.40527 15.4502C8.40527 15.036 8.74106 14.7002 9.15527 14.7002H14.5553C14.9695 14.7002 15.3053 15.036 15.3053 15.4502C15.3053 15.8644 14.9695 16.2002 14.5553 16.2002H9.15527C8.74106 16.2002 8.40527 15.8644 8.40527 15.4502Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.40454 11.4385C8.40454 11.0243 8.74033 10.6885 9.15454 10.6885H12.5105C12.9247 10.6885 13.2605 11.0243 13.2605 11.4385C13.2605 11.8527 12.9247 12.1885 12.5105 12.1885H9.15454C8.74033 12.1885 8.40454 11.8527 8.40454 11.4385Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.18028 4.27249C6.71213 2.58293 9.088 2 12.2897 2C13.2164 2 14.0712 2.05142 14.8415 2.15694C14.9975 2.17831 15.1429 2.24827 15.2569 2.35689L20.9269 7.7569C21.0421 7.86656 21.1194 8.00998 21.1477 8.16645C21.3481 9.27377 21.4397 10.5511 21.4397 12C21.4397 15.4998 20.921 18.0653 19.4074 19.7318C17.8739 21.42 15.4953 22 12.2897 22C9.08873 22 6.71259 21.4199 5.1805 19.7315C3.66838 18.0652 3.14966 15.4999 3.14966 12C3.14966 8.5048 3.6685 5.93992 5.18028 4.27249ZM6.29154 5.28001C5.18082 6.50508 4.64966 8.56519 4.64966 12C4.64966 15.4401 5.18094 17.4999 6.29132 18.7235C7.38173 19.9251 9.20059 20.5 12.2897 20.5C15.384 20.5 17.2054 19.925 18.297 18.7232C19.4084 17.4997 19.9397 15.4402 19.9397 12C19.9397 10.7185 19.8647 9.61383 19.7124 8.67165L14.4006 3.61282C13.7698 3.53823 13.0644 3.5 12.2897 3.5C9.20132 3.5 7.3822 4.07707 6.29154 5.28001Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1841 2.08301C14.5983 2.08301 14.9341 2.4188 14.9341 2.83301V5.49401C14.9341 6.93751 16.104 8.10701 17.5481 8.10701H20.4991C20.9133 8.10701 21.2491 8.4428 21.2491 8.85701C21.2491 9.27122 20.9133 9.60701 20.4991 9.60701H17.5481C15.2762 9.60701 13.4341 7.76652 13.4341 5.49401V2.83301C13.4341 2.4188 13.7699 2.08301 14.1841 2.08301Z"
        fill={colors.primary}
      />
    </svg>
  );
}

export function LogoutIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.791 12.1211H9.75"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8643 9.20508L21.7923 12.1211L18.8643 15.0371"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.3598 7.63C16.0298 4.05 14.6898 2.75 9.35979 2.75C2.25879 2.75 2.25879 5.06 2.25879 12C2.25879 18.94 2.25879 21.25 9.35979 21.25C14.6898 21.25 16.0298 19.95 16.3598 16.37"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ProfileEditIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.3965C4.617 22.3965 2 19.7795 2 12.3965C2 5.01348 4.617 2.39648 12 2.39648C12.414 2.39648 12.75 2.73248 12.75 3.14648C12.75 3.56048 12.414 3.89648 12 3.89648C5.486 3.89648 3.5 5.88248 3.5 12.3965C3.5 18.9105 5.486 20.8965 12 20.8965C18.514 20.8965 20.5 18.9105 20.5 12.3965C20.5 11.9825 20.836 11.6465 21.25 11.6465C21.664 11.6465 22 11.9825 22 12.3965C22 19.7795 19.383 22.3965 12 22.3965Z"
        fill={colors.primary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.2365 9.78219L20.2952 8.58684C21.4472 7.28584 21.3252 5.29084 20.0252 4.13784C19.3952 3.57984 18.5812 3.29984 17.7452 3.35184C16.9052 3.40284 16.1352 3.77884 15.5772 4.40884L9.6932 11.0568C7.8692 13.1148 9.1172 15.8358 9.1712 15.9508C9.2602 16.1398 9.4242 16.2838 9.6232 16.3458C9.6802 16.3648 10.3442 16.5678 11.2192 16.5678C12.2042 16.5678 13.4572 16.3088 14.4092 15.2328L19.0774 9.96183C19.1082 9.93658 19.1374 9.9085 19.1646 9.87763C19.1915 9.8473 19.2155 9.81537 19.2365 9.78219ZM10.4082 14.9918C11.0352 15.1058 12.4192 15.2178 13.2862 14.2388L17.5371 9.43911L15.0656 7.25023L10.8172 12.0518C9.9292 13.0528 10.2122 14.3878 10.4082 14.9918ZM16.0596 6.12688L18.5322 8.31551L19.1722 7.59284C19.7752 6.91084 19.7122 5.86484 19.0312 5.26184C18.7002 4.96984 18.2712 4.82084 17.8362 4.84884C17.3962 4.87684 16.9932 5.07284 16.7002 5.40284L16.0596 6.12688Z"
        fill={colors.primary}
      />
    </svg>
  );
}

export function CanlendarIcon({ colors }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09277 9.9043H20.9167"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4419 13.8096H16.4512"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0044 13.8096H12.0137"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.55811 13.8096H7.56737"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4419 17.6963H16.4512"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0044 17.6963H12.0137"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.55811 17.6963H7.56737"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0439 2.5V5.79078"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.96533 2.5V5.79078"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2383 4.0791H7.77096C4.83427 4.0791 3 5.71504 3 8.72213V17.7718C3 20.8261 4.83427 22.4999 7.77096 22.4999H16.229C19.175 22.4999 21 20.8545 21 17.8474V8.72213C21.0092 5.71504 19.1842 4.0791 16.2383 4.0791Z"
        stroke={colors.primary}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function XboxIcon({ colors }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6514 5.83398C12.5264 5.89457 12.3295 5.99114 12.3105 6.09717C12.3105 6.09717 12.8445 6.61597 12.8218 7.09501C12.9599 6.90286 13.0192 6.66511 12.9875 6.43059C12.9558 6.19607 12.8355 5.98258 12.6514 5.83398Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M6.20834 7.97559C5.99593 7.97559 5.78829 8.0386 5.6117 8.15665C5.43511 8.2747 5.29751 8.44248 5.21631 8.63876C5.13511 8.83504 5.11396 9.051 5.15553 9.25931C5.19711 9.46761 5.29955 9.6589 5.44988 9.80897C5.60021 9.95904 5.79168 10.0611 6.00006 10.1023C6.20844 10.1436 6.42436 10.122 6.6205 10.0405C6.81663 9.95893 6.98417 9.82103 7.10191 9.64423C7.21965 9.46744 7.2823 9.25968 7.28192 9.04727C7.28142 8.76287 7.16809 8.49029 6.96681 8.28936C6.76553 8.08843 6.49274 7.97559 6.20834 7.97559Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M15.0351 13.5311C14.8479 13.5311 14.6648 13.4756 14.5091 13.3716C14.3534 13.2676 14.2321 13.1197 14.1604 12.9467C14.0888 12.7737 14.07 12.5834 14.1066 12.3997C14.1431 12.2161 14.2333 12.0474 14.3657 11.915C14.4981 11.7826 14.6668 11.6924 14.8504 11.6559C15.034 11.6194 15.2244 11.6381 15.3974 11.7098C15.5704 11.7814 15.7182 11.9028 15.8223 12.0584C15.9263 12.2141 15.9818 12.3972 15.9818 12.5844C15.9818 12.8355 15.8821 13.0763 15.7045 13.2538C15.527 13.4314 15.2862 13.5311 15.0351 13.5311Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M19.5362 9.8243C19.9461 9.8243 20.2784 9.49199 20.2784 9.08207C20.2784 8.67215 19.9461 8.33984 19.5362 8.33984C19.1263 8.33984 18.7939 8.67215 18.7939 9.08207C18.7939 9.49199 19.1263 9.8243 19.5362 9.8243Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M17.9112 11.4083C18.3211 11.4083 18.6534 11.076 18.6534 10.6661C18.6534 10.2561 18.3211 9.92383 17.9112 9.92383C17.5013 9.92383 17.1689 10.2561 17.1689 10.6661C17.1689 11.076 17.5013 11.4083 17.9112 11.4083Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M21.1794 20.3382C19.392 20.3382 17.1123 17.0512 16.3966 15.9492H12.0038V15.0025H16.9268L17.0669 15.2241C18.1461 16.9414 20.1134 19.3461 21.1567 19.3896C21.4614 19.3388 21.7509 19.2209 22.0044 19.0444C22.2579 18.8679 22.4689 18.6372 22.6222 18.3691C23.692 16.5097 22.4897 12.9709 22.4764 12.9349V12.916C21.719 10.392 20.7004 7.45908 20.333 7.08229C20.1788 6.99888 20.0443 6.8834 19.9384 6.7436C19.8326 6.60381 19.758 6.44296 19.7196 6.2719C19.7035 6.19677 19.672 6.12581 19.627 6.06355C19.582 6.00128 19.5246 5.94907 19.4583 5.91025C18.8732 5.46908 16.6465 4.81395 16.1864 4.94649C15.8368 5.22858 15.4222 5.41865 14.9803 5.49937H14.9121H9.01598C8.57409 5.41865 8.15944 5.22858 7.80986 4.94649C7.34976 4.81206 5.12308 5.46908 4.54179 5.91593C4.47534 5.95364 4.41746 6.00476 4.37183 6.06604C4.32619 6.12732 4.2938 6.19743 4.27671 6.2719C4.23927 6.4406 4.16662 6.59949 4.06351 6.73817C3.9604 6.87684 3.82916 6.99217 3.67839 7.07661C3.31106 7.45529 2.28292 10.3863 1.53502 12.9103V12.9292C1.52176 12.9652 0.319431 16.504 1.38922 18.3634C1.54254 18.6315 1.75358 18.8622 2.00705 19.0387C2.26052 19.2152 2.55007 19.3331 2.85474 19.3839C3.89802 19.3404 5.8653 16.9357 6.94456 15.2184L7.08468 14.9968H12.0076V15.9436H7.59969C6.88397 17.0455 4.60428 20.3326 2.81687 20.3326H2.79794L2.71273 20.3231C2.26699 20.2516 1.84286 20.0813 1.47136 19.8248C1.09987 19.5683 0.790397 19.232 0.565577 18.8405C-0.699237 16.6422 0.539069 12.9103 0.631848 12.6357C1.27751 10.4526 2.45901 6.73579 3.15201 6.29651C3.32053 6.18859 3.3281 6.1564 3.36408 6.02764C3.45266 5.67394 3.67008 5.36605 3.97376 5.16424C4.6251 4.66437 7.61863 3.54724 8.39872 4.19858C8.61094 4.37478 8.86008 4.50097 9.12769 4.5678H14.8686C15.1389 4.50561 15.3914 4.38257 15.607 4.20805C16.3871 3.55671 19.3806 4.67384 20.032 5.1737C20.3316 5.37424 20.5467 5.67832 20.636 6.02764C20.672 6.1564 20.6795 6.18859 20.8481 6.29651C21.5354 6.73579 22.7226 10.4526 23.3701 12.6357C23.4629 12.9103 24.6955 16.6422 23.4383 18.8405C23.2131 19.233 22.9031 19.5703 22.531 19.8277C22.1589 20.0852 21.734 20.2564 21.2873 20.3288L21.204 20.3382H21.1794ZM15.0295 14.6579C14.7333 14.6577 14.4404 14.5944 14.1706 14.472C13.9008 14.3496 13.6602 14.1711 13.4648 13.9484C13.2695 13.7256 13.1239 13.4637 13.0378 13.1802C12.9518 12.8967 12.9272 12.5981 12.9657 12.3044C13.0163 11.919 13.1738 11.5555 13.4202 11.2549C13.6667 10.9544 13.9924 10.7288 14.3604 10.6037C14.7284 10.4786 15.1241 10.459 15.5027 10.547C15.8812 10.6351 16.2276 10.8274 16.5026 11.1021C16.7289 11.3271 16.9002 11.6014 17.003 11.9036C17.1058 12.2058 17.1374 12.5276 17.0953 12.844C17.0331 13.2983 16.824 13.7198 16.4999 14.0443C16.1758 14.3687 15.7545 14.5782 15.3003 14.6409C15.2119 14.6552 15.1228 14.664 15.0333 14.6674L15.0295 14.6579ZM15.0295 11.4391C14.9797 11.4363 14.9298 11.4363 14.88 11.4391C14.5812 11.479 14.3105 11.636 14.1274 11.8755C13.9444 12.115 13.864 12.4174 13.9039 12.7162C13.9438 13.015 14.1008 13.2857 14.3403 13.4687C14.5798 13.6518 14.8822 13.7322 15.181 13.6923C15.4677 13.6551 15.7294 13.51 15.9128 13.2865C16.0962 13.0631 16.1876 12.7782 16.1683 12.4898C16.149 12.2014 16.0204 11.9311 15.8089 11.7342C15.5973 11.5372 15.3186 11.4283 15.0295 11.4296V11.4391ZM6.20423 11.4391C5.86317 11.4381 5.52619 11.3649 5.21549 11.2242C4.9048 11.0835 4.62743 10.8786 4.40166 10.623C4.1759 10.3674 4.00687 10.0668 3.9057 9.74108C3.80453 9.41537 3.77352 9.07192 3.81471 8.73336C3.88674 8.20636 4.12935 7.71745 4.50546 7.34134C4.88157 6.96523 5.37049 6.72261 5.89749 6.65058C6.2642 6.6029 6.63696 6.64003 6.98706 6.75911C7.33716 6.8782 7.65525 7.07606 7.91682 7.33745C8.1784 7.59885 8.37648 7.9168 8.49581 8.26681C8.61514 8.61683 8.65253 8.98956 8.60511 9.3563C8.53307 9.8833 8.29046 10.3722 7.91435 10.7483C7.53824 11.1244 7.04933 11.3671 6.52233 11.4391C6.41801 11.4513 6.31304 11.457 6.20802 11.4561L6.20423 11.4391ZM6.20423 7.55754C6.14088 7.55743 6.0776 7.56186 6.01488 7.57079C5.63938 7.62177 5.29841 7.81678 5.06406 8.11458C4.82971 8.41238 4.72035 8.78964 4.75909 9.16661C4.79783 9.54357 4.98164 9.8907 5.27167 10.1346C5.56169 10.3785 5.93519 10.5001 6.31322 10.4736C6.69125 10.4472 7.04417 10.2748 7.29738 9.99281C7.5506 9.71088 7.68426 9.34153 7.6701 8.96284C7.65595 8.58415 7.49509 8.2258 7.22154 7.96356C6.94799 7.70131 6.58318 7.55571 6.20423 7.55754Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M14.5526 9.27278C14.5177 9.42918 14.4389 9.57242 14.3256 9.68574C14.2123 9.79907 14.0691 9.87781 13.9126 9.91276C13.8506 9.92702 13.787 9.93401 13.7233 9.93358C13.5135 9.93411 13.3108 9.85717 13.1542 9.71751C12.9975 9.57786 12.8979 9.38532 12.8745 9.17678C12.851 8.96825 12.9053 8.75839 13.027 8.58743C13.1487 8.41647 13.3292 8.29643 13.534 8.25032C13.5962 8.23685 13.6596 8.22987 13.7233 8.22949C13.8515 8.22936 13.9781 8.25816 14.0937 8.31376C14.2092 8.36936 14.3107 8.45031 14.3906 8.5506C14.4705 8.65088 14.5267 8.76791 14.5551 8.89295C14.5835 9.01799 14.5833 9.14782 14.5545 9.27278H14.5526Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M11.2654 9.27278C11.2296 9.42913 11.1504 9.5722 11.0368 9.68544C10.9232 9.79869 10.78 9.87749 10.6235 9.91276C10.5614 9.92715 10.4979 9.93414 10.4341 9.93358C10.2574 9.9334 10.0852 9.87827 9.94118 9.77585C9.79719 9.67343 9.6886 9.52877 9.63046 9.36191C9.57231 9.19505 9.56748 9.01424 9.61664 8.84451C9.6658 8.67478 9.76651 8.52454 9.90483 8.41458C10.0431 8.30461 10.2122 8.24038 10.3887 8.23076C10.5651 8.22114 10.7402 8.26661 10.8896 8.36088C11.0391 8.45516 11.1555 8.59356 11.2228 8.75694C11.2902 8.92032 11.305 9.10058 11.2654 9.27278Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M12.0493 6.33398C11.574 6.70131 11.4168 7.00805 11.3657 7.18224C11.4516 7.27851 11.5566 7.35582 11.6741 7.40921C11.7915 7.46261 11.9188 7.49092 12.0478 7.49235C12.1768 7.49377 12.3047 7.46828 12.4233 7.41749C12.5419 7.3667 12.6486 7.29174 12.7366 7.19739C12.6836 7.02888 12.5378 6.71267 12.0493 6.33398Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M17.9112 8.31648C18.3211 8.31648 18.6534 7.98418 18.6534 7.57426C18.6534 7.16434 18.3211 6.83203 17.9112 6.83203C17.5013 6.83203 17.1689 7.16434 17.1689 7.57426C17.1689 7.98418 17.5013 8.31648 17.9112 8.31648Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M12.4506 5.70313C12.3271 5.64398 12.1919 5.61328 12.0549 5.61328C11.9179 5.61328 11.7827 5.64398 11.6592 5.70313C11.7947 5.71413 11.9251 5.75977 12.0379 5.83567C12.1607 5.75447 12.3035 5.70862 12.4506 5.70313Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M11.4567 5.83984C11.2785 5.98523 11.1605 6.19151 11.1256 6.41883C11.0906 6.64614 11.1411 6.87835 11.2674 7.07058C11.2674 6.59911 11.7786 6.09735 11.7786 6.09735C11.7672 5.99321 11.5817 5.89286 11.4567 5.83984Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M16.4043 9.8243C16.8143 9.8243 17.1466 9.49199 17.1466 9.08207C17.1466 8.67215 16.8143 8.33984 16.4043 8.33984C15.9944 8.33984 15.6621 8.67215 15.6621 9.08207C15.6621 9.49199 15.9944 9.8243 16.4043 9.8243Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M9.4762 12.2943V11.4062H8.76048V12.2943C8.76048 12.3102 8.75734 12.3259 8.75125 12.3406C8.74516 12.3553 8.73624 12.3687 8.72498 12.38C8.71373 12.3912 8.70037 12.4001 8.68567 12.4062C8.67097 12.4123 8.65521 12.4155 8.6393 12.4155H7.76074V13.1312H8.64876C8.6809 13.1312 8.71172 13.1439 8.73445 13.1667C8.75718 13.1894 8.76994 13.2202 8.76994 13.2523V14.1404H9.48566V13.2523C9.48566 13.2202 9.49843 13.1894 9.52115 13.1667C9.54388 13.1439 9.5747 13.1312 9.60684 13.1312H10.4949V12.4155H9.59738C9.56524 12.4155 9.53441 12.4027 9.51169 12.38C9.48896 12.3572 9.4762 12.3264 9.4762 12.2943Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M7.5 17.289V19.0143C7.50066 19.1833 7.56818 19.345 7.68776 19.4642C7.80734 19.5835 7.96925 19.6504 8.13803 19.6504H9.86197C10.0308 19.6504 10.1927 19.5835 10.3122 19.4642C10.4318 19.345 10.4993 19.1833 10.5 19.0143V17.289C10.5 17.1196 10.4328 16.9572 10.3131 16.8374C10.1935 16.7177 10.0312 16.6504 9.86197 16.6504H8.13803C7.96882 16.6504 7.80653 16.7177 7.68688 16.8374C7.56722 16.9572 7.5 17.1196 7.5 17.289Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
      <path
        d="M7.31276 17.4039V17.2884C7.31375 17.0687 7.40145 16.8583 7.55678 16.703C7.7121 16.5477 7.92247 16.46 8.14213 16.459H15.864C16.0829 16.4624 16.2919 16.5509 16.4467 16.7057C16.6015 16.8605 16.6899 17.0695 16.6934 17.2884V18.9433C16.6934 19.0521 16.6719 19.1599 16.6302 19.2604C16.5885 19.3609 16.5274 19.4522 16.4503 19.5291C16.3733 19.606 16.2818 19.6669 16.1812 19.7083C16.0806 19.7498 15.9728 19.771 15.864 19.7708H8.13834C8.02952 19.771 7.92171 19.7498 7.8211 19.7083C7.72049 19.6669 7.62904 19.606 7.552 19.5291C7.47496 19.4522 7.41384 19.3609 7.37214 19.2604C7.33044 19.1599 7.30897 19.0521 7.30897 18.9433V18.8278M13.8246 18.7691C13.8251 18.8968 13.8762 19.0192 13.9667 19.1093C14.0572 19.1995 14.1798 19.2501 14.3075 19.2501H15.6121C15.7399 19.2501 15.8624 19.1995 15.9529 19.1093C16.0434 19.0192 16.0945 18.8968 16.095 18.7691V17.4626C16.0945 17.3348 16.0434 17.2125 15.9529 17.1224C15.8624 17.0322 15.7399 16.9816 15.6121 16.9816H14.3075C14.1798 16.9816 14.0572 17.0322 13.9667 17.1224C13.8762 17.2125 13.8251 17.3348 13.8246 17.4626V18.7691ZM10.9048 18.7691C10.9053 18.8968 10.9564 19.0192 11.0469 19.1093C11.1374 19.1995 11.2599 19.2501 11.3877 19.2501H12.6923C12.8199 19.2501 12.9422 19.1994 13.0324 19.1092C13.1226 19.019 13.1733 18.8967 13.1733 18.7691V17.4626C13.1733 17.335 13.1226 17.2127 13.0324 17.1225C12.9422 17.0323 12.8199 16.9816 12.6923 16.9816H11.3877C11.2599 16.9816 11.1374 17.0322 11.0469 17.1224C10.9564 17.2125 10.9053 17.3348 10.9048 17.4626V18.7691ZM7.87514 18.7691C7.87514 18.8967 7.92581 19.019 8.01601 19.1092C8.10621 19.1994 8.22854 19.2501 8.3561 19.2501H9.66264C9.78921 19.2486 9.91009 19.1972 9.99906 19.1072C10.088 19.0172 10.1379 18.8957 10.1379 18.7691V17.4626C10.1379 17.3994 10.1255 17.3369 10.1013 17.2785C10.0771 17.2202 10.0417 17.1671 9.99705 17.1225C9.95239 17.0778 9.89937 17.0424 9.84102 17.0182C9.78266 16.994 9.72012 16.9816 9.65696 16.9816H8.35042C8.22286 16.9816 8.10053 17.0323 8.01033 17.1225C7.92013 17.2127 7.86946 17.335 7.86946 17.4626L7.87514 18.7691Z"
        fill={colors.primary}
        fill-opacity="0.5"
      />
    </svg>
  );
}

export function WalletBg({ colors, style }) {
  return (
    <svg
      width="351"
      height="180"
      viewBox="0 0 351 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M592.428 176.93C599.951 166.731 599.148 153.531 593.654 142.503C588.16 131.475 578.53 122.198 568.729 113.384C555.773 101.731 541.822 90.2708 524.359 83.6115C500.02 74.3307 471.759 75.4345 445.186 78.6328C398.001 84.313 352.159 95.951 307.577 109.793C259.788 124.631 211.057 142.365 160.015 139.993C114.21 137.865 82.9629 119.569 49.8899 95.9909C19.0438 73.9999 -6.47125 45.6305 -44.749 31.243C-94.9752 12.3639 -156.798 22.0736 -201.489 48.6593C-246.181 75.245 -275.276 116.426 -291.911 159.489"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M596.772 172.415C603.608 163.609 601.609 151.82 595.223 141.475C588.856 131.161 578.864 122.124 568.599 113.831C555.085 102.913 540.737 91.8963 522.814 85.6626C497.342 76.8007 467.829 77.6269 440.248 80.4113C393.246 85.1539 347.673 96.0971 303.459 109.082C256.429 122.894 208.656 139.961 158.491 137.331C112.73 134.932 80.8787 117.245 47.4699 94.9019C16.2126 74.0944 -9.76458 47.6284 -47.7065 34.4811C-97.324 17.2876 -157.85 27.4777 -202.393 53.5962C-247.121 79.7713 -276.956 119.117 -294.591 161.074"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M601.114 167.9C607.261 160.488 604.094 150.14 596.79 140.45C589.572 130.873 579.203 122.053 568.466 114.282C554.403 104.102 539.635 93.5341 521.267 87.7159C494.642 79.2829 463.914 79.8331 435.309 82.1903C388.515 86.0453 343.196 96.2437 299.341 108.37C253.078 121.164 206.249 137.551 156.966 134.668C111.25 131.994 78.851 114.857 45.0473 93.8133C13.4379 74.1347 -13.0421 49.6302 -50.6644 37.7196C-99.653 22.2117 -158.903 32.8822 -203.297 58.5353C-248.064 84.2998 -278.637 121.809 -297.274 162.662"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M605.456 163.385C610.915 157.366 606.612 148.487 598.356 139.422C590.324 130.602 579.548 121.983 568.334 114.73C553.736 105.288 538.526 95.1794 519.722 89.7669C491.931 81.7694 460.017 82.0487 430.372 83.967C383.805 86.9791 338.731 96.3896 295.226 107.657C249.743 119.436 203.846 135.134 155.444 132.005C109.771 129.053 76.7936 112.501 42.6296 92.7225C10.6334 74.1991 -16.2984 51.628 -53.6195 40.9558C-101.961 27.1302 -159.952 38.2861 -204.198 63.4704C-249.002 88.8227 -280.314 124.496 -299.953 164.244"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M609.797 158.87C614.571 154.244 609.172 146.853 599.923 138.395C591.115 130.341 579.904 121.913 568.202 115.179C553.076 106.475 537.406 96.8336 518.175 91.82C489.206 84.2681 456.129 84.2797 425.433 85.7459C379.111 87.9584 334.277 96.5411 291.108 106.944C246.416 117.714 201.44 132.708 153.919 129.341C108.287 126.107 74.7272 110.142 40.209 91.6322C7.82202 74.2642 -19.5413 53.628 -56.5774 44.1909C-104.249 32.0442 -161.005 43.6872 -205.102 68.4044C-249.943 93.3494 -281.994 127.186 -302.634 165.83"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M614.139 154.355C618.224 151.124 611.776 145.229 601.49 137.37C591.956 130.084 580.268 121.843 568.069 115.628C552.431 107.659 536.281 98.496 516.63 93.8714C486.472 86.7749 452.251 86.5222 420.495 87.523C374.429 88.9758 329.836 96.6924 286.99 106.231C243.101 116.002 199.032 130.276 152.394 126.678C106.801 123.16 72.6592 107.787 37.7889 90.5434C5.00704 74.3324 -22.7655 55.6261 -59.5329 47.4292C-106.514 36.9548 -161.99 49.1713 -206.004 73.3433C-250.818 97.9541 -283.673 129.876 -305.314 167.415"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M618.481 149.841C621.878 148.002 614.426 143.605 603.058 136.342C592.842 129.816 580.641 121.77 567.937 116.077C551.794 108.841 535.149 100.167 515.083 95.9245C483.728 89.2952 448.382 88.7798 415.557 89.3035C369.756 90.0332 325.406 96.8521 282.872 105.521C239.797 114.3 196.626 127.841 150.87 124.018C105.315 120.211 70.5851 105.435 35.3687 89.4564C2.18792 74.4023 -25.9693 57.6227 -62.4904 50.6692C-108.76 41.8588 -163.032 54.5906 -206.908 78.2822C-251.748 102.494 -285.352 132.566 -307.995 169.001"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M622.823 145.326C625.532 144.88 617.119 141.971 604.625 135.317C593.768 129.534 581.019 121.697 567.805 116.528C551.167 110.02 534.013 101.848 513.536 97.9776C480.978 91.8254 444.518 91.0524 410.617 91.0823C365.091 91.1222 320.987 97.0152 278.752 104.81C236.501 112.606 194.216 125.398 149.343 121.355C103.827 117.254 68.5066 103.081 32.9463 88.3677C-0.635525 74.4723 -29.1571 59.6127 -65.4502 53.9075C-110.982 46.7495 -164.079 60.0083 -207.814 83.2211C-252.682 107.036 -287.036 135.259 -310.68 170.588"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M627.164 140.81C629.186 141.758 619.847 140.317 606.192 134.289C594.726 129.229 581.406 121.616 567.672 116.974C550.55 111.188 532.873 103.531 511.991 100.027C478.222 94.3616 440.661 93.3359 405.681 92.8572C360.435 92.2388 316.582 97.1809 274.639 104.093C233.224 110.918 191.812 122.942 147.824 118.688C102.345 114.29 66.4304 100.725 30.5322 87.2734C-3.45677 74.5383 -32.3163 61.5887 -68.3997 57.1387C-113.175 51.6181 -165.117 65.4171 -208.709 88.1511C-253.613 111.57 -288.711 137.946 -313.357 172.17"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M631.506 136.296C632.841 138.638 622.601 138.636 607.76 133.264C595.71 128.902 581.799 121.533 567.54 117.425C549.937 112.353 531.729 105.227 510.444 102.082C475.462 96.9135 436.806 95.6402 400.74 94.6378C355.778 93.3877 312.188 97.359 270.519 103.383C229.953 109.248 189.4 120.485 146.298 116.027C100.855 111.326 64.3441 98.378 28.11 86.1865C-6.28811 74.6117 -35.4651 63.5621 -71.3592 60.3788C-115.355 56.4773 -166.165 70.8332 -209.617 93.0918C-254.547 116.107 -290.392 140.636 -316.038 173.756"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M635.85 131.781C636.497 135.516 625.373 136.926 609.329 132.236C596.709 128.548 582.196 121.443 567.41 117.874C549.335 113.51 530.588 106.926 508.899 104.133C472.7 99.4717 432.955 97.9573 395.804 96.4147C351.127 94.5595 307.809 97.5417 266.403 102.67C226.696 107.589 186.994 118.02 144.775 113.364C99.3672 108.357 62.2578 96.0307 25.6899 85.0959C-9.12135 74.6863 -38.5955 65.5186 -74.3167 63.6152C-117.512 61.3129 -167.211 76.2456 -210.521 98.0271C-255.483 120.64 -292.071 143.324 -318.72 175.339"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M640.192 127.266C640.151 132.394 628.154 135.185 610.897 131.211C597.713 128.174 582.597 121.348 567.278 118.323C548.732 114.661 529.44 108.631 507.355 106.186C469.936 102.042 429.105 100.293 390.866 98.1952C346.474 95.7582 303.439 97.738 262.285 101.96C223.448 105.945 184.586 115.55 143.251 110.704C97.8773 105.385 60.1654 93.6902 23.2698 84.0105C-11.9568 74.7679 -41.7078 67.4653 -77.2722 66.8569C-119.649 66.1321 -168.257 81.6616 -211.422 102.968C-256.417 125.178 -293.749 146.017 -321.399 176.928"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M644.533 122.751C643.804 129.272 630.936 133.416 612.464 130.183C598.716 127.778 582.998 121.246 567.145 118.771C548.133 115.802 528.293 110.343 505.807 108.237C467.167 104.62 425.254 102.643 385.928 99.9717C341.822 96.9746 299.081 97.942 258.169 101.247C220.209 104.312 182.179 113.069 141.728 108.039C96.3889 102.4 58.0725 91.3476 20.8512 82.9179C-14.7947 74.8456 -44.8062 69.3865 -80.2281 70.0897C-121.773 70.9158 -169.306 87.0687 -212.325 107.901C-257.354 129.709 -295.428 148.705 -324.08 178.512"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M648.875 118.236C647.459 126.151 633.715 131.621 614.032 129.158C599.716 127.366 583.399 121.14 567.016 119.222C547.538 116.94 527.148 112.061 504.263 110.292C464.401 107.21 421.403 105.014 380.99 101.752C337.17 98.2167 294.734 98.1618 254.052 100.536C216.981 102.7 179.774 110.584 140.204 105.378C94.8995 99.4152 55.9744 89.0124 18.4315 81.8311C-17.6357 74.9324 -47.8956 71.2936 -83.1852 73.3299C-123.885 75.6788 -170.356 92.48 -213.228 112.84C-258.294 134.243 -297.107 151.395 -326.76 180.097"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M653.217 113.721C651.114 123.03 636.483 129.802 615.599 128.13C600.707 126.938 583.802 121.027 566.883 119.669C546.939 118.068 526 113.779 502.718 112.341C461.635 109.803 417.55 107.396 376.054 103.528C332.515 99.4699 290.396 98.391 249.936 99.8206C213.761 101.099 177.37 108.089 138.681 102.711C93.4135 96.4195 53.8778 86.6765 16.0133 80.737C-20.4773 75.0153 -50.9774 73.1701 -86.1387 76.5629C-125.988 80.4079 -171.404 97.884 -214.127 117.774C-259.228 138.769 -298.784 154.082 -329.437 181.679"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M657.558 109.207C654.767 119.909 639.241 127.964 617.166 127.105C601.69 126.501 584.202 120.911 566.75 120.12C546.338 119.194 524.853 115.507 501.17 114.395C458.866 112.41 413.69 109.798 371.113 105.307C327.853 100.744 286.062 98.6407 245.815 99.1095C210.542 99.5201 174.961 105.591 137.154 100.05C91.9208 93.421 51.7744 84.348 13.5903 79.6503C-23.3237 75.1088 -54.0598 75.0306 -89.0991 79.8032C-128.095 85.1127 -172.459 103.294 -215.034 122.713C-260.173 143.301 -300.466 156.774 -332.123 183.267"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M661.9 104.692C658.422 116.787 641.989 126.111 618.733 126.078C602.661 126.054 584.604 120.79 566.618 120.569C545.738 120.313 523.708 117.236 499.626 116.448C456.102 115.023 409.831 112.219 366.176 107.087C323.19 102.034 281.737 98.9102 241.698 98.3998C207.333 97.961 172.556 103.088 135.63 97.3908C90.4353 90.4173 49.6743 82.0259 11.1706 78.5649C-26.1668 75.207 -57.1411 76.8693 -92.0562 83.0432C-130.202 89.7906 -173.511 108.703 -215.937 127.654C-261.113 147.831 -302.145 159.466 -334.801 184.853"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M666.242 100.177C662.075 113.665 644.723 124.244 620.301 125.052C603.624 125.604 585.001 120.663 566.486 121.018C545.133 121.426 522.561 118.968 498.078 118.499C453.336 117.641 405.964 114.654 361.237 108.864C318.522 103.334 277.415 99.1961 237.582 97.6851C204.127 96.4167 170.156 100.573 134.107 94.7244C88.9514 87.4002 47.5757 79.702 8.75242 77.4711C-29.0103 75.3018 -60.2269 78.6713 -95.0097 86.2765C-132.31 94.4319 -174.561 114.102 -216.837 132.586C-262.054 152.356 -303.822 162.152 -337.479 186.435"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M670.584 95.6617C665.729 110.545 647.444 122.367 621.868 124.024C604.576 125.145 585.396 120.532 566.354 121.466C544.527 122.537 521.416 120.705 496.531 120.552C450.572 120.269 402.09 117.109 356.297 110.643C313.849 104.648 273.092 99.505 233.462 96.9733C200.919 94.8937 167.752 98.0521 132.582 92.0628C87.4654 84.3778 45.4749 77.3844 6.32998 76.3836C-31.8562 75.4062 -63.3292 80.4564 -97.9695 89.5161C-134.44 99.0545 -175.62 119.508 -217.743 137.524C-263 156.882 -305.504 164.845 -340.165 188.023"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M674.927 91.147C669.387 107.423 650.155 120.484 623.437 122.999C605.521 124.686 585.79 120.401 566.223 121.917C543.918 123.646 520.276 122.445 494.988 122.605C447.813 122.904 398.214 119.581 351.363 112.422C309.175 105.975 268.776 99.8393 229.348 96.262C197.715 93.3928 165.356 95.5273 131.062 89.3999C85.9874 81.3476 43.3802 75.0706 3.91372 75.2933C-34.6958 75.5111 -66.4416 82.2136 -100.923 92.7528C-136.577 103.651 -176.673 124.909 -218.643 142.462C-263.941 161.405 -307.181 167.535 -342.841 189.609"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M679.269 86.6316C673.041 104.301 652.852 118.593 625.005 121.971C606.455 124.222 586.181 120.262 566.091 122.365C543.305 124.749 519.132 124.185 493.442 124.657C445.053 125.543 394.329 122.069 346.423 114.2C304.489 107.311 264.449 100.196 225.229 95.55C194.503 91.9095 162.954 92.9933 129.535 86.738C84.5059 78.3083 41.2798 72.7611 1.49169 74.2056C-37.5392 75.622 -69.5781 83.9502 -103.88 95.9905C-138.739 108.227 -177.729 130.309 -219.548 147.398C-264.889 165.928 -308.862 170.224 -345.526 191.192"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M683.611 82.1171C676.694 101.179 655.539 116.7 626.572 120.946C607.381 123.758 586.568 120.126 565.959 122.814C542.689 125.851 517.992 125.929 491.895 126.709C442.295 128.189 390.435 124.575 341.485 115.979C299.8 108.658 260.115 100.581 221.113 94.8389C191.289 90.447 160.561 90.4553 128.013 84.077C83.0322 75.2616 39.1874 70.4541 -0.926422 73.1172C-40.3766 75.737 -72.7351 85.6662 -106.836 99.2291C-140.921 112.787 -178.785 135.709 -220.45 152.337C-265.834 170.45 -310.54 172.915 -348.205 192.78"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M687.953 77.6021C680.348 98.0571 658.218 114.803 628.139 119.918C608.299 123.293 586.951 119.985 565.826 123.263C542.07 126.95 516.852 127.677 490.35 128.76C439.543 130.84 386.533 127.098 336.547 117.756C295.104 110.011 255.772 100.991 216.995 94.1241C188.064 89.0008 158.167 87.9069 126.488 81.4106C81.5585 72.1979 37.0928 68.1468 -3.34669 72.025C-43.2142 75.8484 -75.9207 87.36 -109.792 102.464C-143.127 117.329 -179.842 141.103 -221.352 157.271C-266.78 174.965 -312.219 175.603 -350.883 194.363"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M692.294 73.0874C684.002 94.9371 660.889 112.905 629.705 118.893C609.209 122.828 587.331 119.844 565.692 123.714C541.443 128.051 515.712 129.427 488.801 130.815C436.787 133.498 382.62 129.64 331.606 119.536C290.397 111.374 251.409 101.435 212.875 93.4144C184.826 87.5763 155.775 85.3571 124.961 78.751C80.0887 69.1294 35.0001 65.8463 -5.76909 70.938C-46.0518 75.9699 -79.137 89.0442 -112.751 105.704C-145.364 121.867 -180.902 146.501 -222.258 162.212C-267.731 179.487 -313.9 178.296 -353.568 195.952"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M696.637 68.5724C687.658 91.8151 663.551 111.007 631.272 117.866C610.117 122.362 587.71 119.699 565.562 124.161C540.82 129.146 514.577 131.176 487.258 132.865C434.042 136.156 378.702 132.195 326.671 121.312C285.69 112.741 247.031 101.9 208.76 92.6995C181.578 86.1648 153.39 82.7953 123.439 76.0844C78.6277 66.0423 32.9142 63.5421 -8.18681 69.8457C-48.8827 76.0861 -82.375 90.713 -115.706 108.937C-147.625 126.39 -181.96 151.89 -223.159 167.144C-268.677 183.996 -315.579 180.981 -356.247 197.531"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M700.978 64.0576C691.311 88.6934 666.205 109.107 632.839 116.84C611.017 121.897 588.085 119.556 565.429 124.611C540.189 130.243 513.44 132.928 485.711 134.92C431.293 138.824 374.771 134.772 321.732 123.092C280.973 114.117 242.626 102.401 204.644 91.9898C178.314 84.7719 151.006 80.2338 121.916 73.4249C77.1718 62.9505 30.8294 61.2483 -10.6054 68.7604C-51.7105 76.2126 -85.6465 92.3788 -118.66 112.179C-149.912 130.92 -183.017 157.286 -224.059 172.086C-269.624 188.515 -317.255 183.676 -358.926 199.122"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M705.32 59.5425C694.965 85.5713 668.856 107.207 634.407 115.812C611.914 121.431 588.459 119.41 565.297 125.06C539.558 131.339 512.307 134.682 484.164 136.971C428.548 141.494 370.831 137.361 316.792 124.87C276.247 115.498 238.191 102.929 200.524 91.2781C175.025 83.3903 148.625 77.6636 120.39 70.7632C75.7187 59.8434 28.7453 58.9523 -13.0295 67.6713C-54.5416 76.337 -88.9499 94.0375 -121.622 115.417C-152.232 135.446 -184.081 162.679 -224.967 177.023C-270.578 193.026 -318.938 186.367 -361.61 200.708"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M709.662 55.0278C698.619 82.4497 671.5 105.308 635.974 114.787C612.806 120.969 588.83 119.264 565.165 125.509C538.923 132.434 511.175 136.437 482.619 139.022C425.808 144.167 366.88 139.966 311.856 126.648C271.518 116.883 233.727 103.482 196.408 90.5635C171.719 82.0175 146.249 75.0855 118.868 68.0971C74.2797 56.7168 26.6671 56.6519 -15.4476 66.5794C-57.3628 76.4586 -92.2759 95.6901 -124.577 118.652C-154.573 139.973 -185.142 168.065 -225.868 181.957C-271.527 197.531 -320.617 189.053 -364.289 202.289"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M714.006 50.5127C702.275 79.3292 674.142 103.408 637.544 113.759C613.698 120.504 589.202 119.117 565.035 125.958C538.288 133.53 510.045 138.192 481.074 141.075C423.07 146.845 362.917 142.591 306.918 128.426C266.778 118.274 229.225 104.061 192.29 89.8518C168.389 80.6558 143.876 72.5037 117.345 65.4355C72.8467 53.5797 24.5929 54.3593 -17.8658 65.4903C-60.182 76.5847 -95.6263 97.3472 -127.531 121.888C-156.934 144.506 -186.231 173.389 -226.768 186.894C-272.51 201.969 -322.292 191.743 -366.968 203.874"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M718.347 45.998C705.93 76.2076 676.777 101.51 639.11 112.734C614.583 120.043 589.568 118.971 564.902 126.408C537.646 134.625 508.915 139.951 479.527 143.128C420.332 149.526 358.941 145.231 301.979 130.205C262.03 119.668 224.679 104.663 188.172 89.1406C165.03 79.3012 141.508 69.9173 115.82 62.7726C71.4234 50.4248 22.5447 52.1287 -20.2865 64.4017C-62.9752 76.7761 -99.0057 99.0082 -130.489 125.127C-159.322 149.046 -187.284 178.793 -227.672 191.831C-273.451 206.496 -323.974 194.433 -369.649 205.461"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M722.689 41.4829C709.585 73.0855 679.41 99.613 640.678 111.706C615.465 119.579 589.917 118.79 564.77 126.855C536.988 135.681 507.796 141.751 477.982 145.179C417.615 152.297 354.956 147.884 297.042 131.982C257.278 121.064 220.094 105.282 184.057 88.4272C161.65 77.9462 139.149 67.3239 114.298 60.1093C70.0134 47.2529 20.4631 49.8029 -22.704 63.311C-65.7998 76.8706 -102.402 100.672 -133.444 128.363C-161.727 153.594 -188.333 184.197 -228.575 196.768C-274.391 211.021 -325.653 197.124 -372.329 207.046"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M727.03 36.9683C713.238 69.9639 682.038 97.7165 642.245 110.681C616.346 119.119 590.297 118.679 564.638 127.306C536.36 136.815 506.66 143.471 476.435 147.232C414.867 154.897 350.956 150.554 292.103 133.763C252.515 122.467 215.46 105.92 179.939 87.7159C158.236 76.5949 136.794 64.7275 112.773 57.4482C68.6146 44.0631 18.3803 47.4792 -25.1246 62.2241C-68.6296 76.969 -105.82 102.344 -136.4 131.603C-164.152 158.154 -189.384 189.604 -229.477 201.707C-275.331 215.549 -327.33 199.815 -375.01 208.632"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M543.196 142.174C538.413 100.205 514.982 59.8187 478.241 30.2142C467.789 21.7912 455.793 14.0065 441.541 11.124C400.356 2.79739 361.158 31.8533 329.592 49.1299C291.493 69.9822 253.956 91.6307 213.857 109.893C191.344 120.146 164.563 129.492 140.568 121.802C116.27 114.014 104.638 92.1028 92.6159 73.1822C78.6075 51.1347 60.5138 30.2807 35.9615 15.6173C11.4113 0.955529 -20.2776 -6.94221 -50.0143 -1.72082C-73.3005 2.36685 -93.5335 13.93 -111.761 26.4524C-159.657 59.3549 -198.639 100.863 -225.135 147.169"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M544.255 140.254C539.626 99.6381 515.743 61.4211 478.322 31.8233C467.874 23.5598 456.015 15.8615 441.96 12.9358C401.27 4.44299 362.59 32.0776 331.104 48.7558C297.535 66.5377 264.38 85.2406 229.146 101.837C224.814 103.885 220.458 105.9 216.072 107.875C193.73 117.937 167.27 127.143 143.518 119.87C119.452 112.51 107.654 91.491 95.4922 73.36C81.2843 52.245 63.1398 32.2787 38.7666 18.2669C14.3304 4.27509 -16.9941 -3.21372 -46.4072 1.91292C-66.3959 5.39384 -84.1557 14.2591 -100.348 24.3943C-102.856 25.9619 -105.311 27.5727 -107.755 29.1735C-156.262 60.9357 -195.095 99.2258 -220.736 144.039"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M545.313 138.334C540.839 99.073 516.511 63.022 478.406 33.4342C467.964 25.327 456.239 17.7201 442.38 14.7495C402.184 6.09046 364.023 32.3054 332.617 48.3852C299.381 65.4008 266.52 83.62 231.261 99.9424C226.962 101.949 222.638 103.924 218.286 105.862C196.115 115.733 169.975 124.799 146.465 117.944C122.63 111.012 110.667 90.8844 98.3643 73.5446C83.9569 53.3639 65.7635 34.282 41.5654 20.9234C17.2431 7.59985 -13.715 0.521643 -42.8065 5.55518C-62.616 8.97793 -80.2598 17.5589 -96.3749 27.3101C-98.8725 28.8179 -101.309 30.3788 -103.756 31.9032C-152.899 62.5283 -191.555 97.5985 -216.344 140.917"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M546.372 136.415C542.052 98.5076 517.286 64.6209 478.489 35.0447C468.058 27.0921 456.463 19.5767 442.801 16.5629C403.1 7.73758 365.464 32.5346 334.131 48.0126C301.235 64.2635 268.61 81.9242 233.378 98.0471C229.105 100.004 224.82 101.947 220.503 103.847C198.503 113.527 172.685 122.453 149.417 116.017C125.813 109.512 113.726 90.2574 101.24 73.7289C86.6825 54.4558 68.4342 36.2333 44.3704 23.5796C20.2028 10.8727 -10.4316 4.25666 -39.1975 9.19711C-58.8279 12.5617 -76.3536 20.86 -92.3955 30.2256C-94.8849 31.6735 -97.3011 33.1846 -99.7478 34.6325C-149.553 64.1206 -188.009 95.9692 -211.941 137.795"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M547.43 134.496C543.263 97.9426 518.068 66.217 478.571 36.654C468.151 28.8544 456.685 21.4321 443.22 18.375C404.014 9.38181 366.909 32.7609 335.643 47.6387C303.094 63.1267 270.733 80.277 235.492 96.1506C231.248 98.0623 226.998 99.9689 222.715 101.831C200.887 111.321 175.388 120.106 152.362 114.087C128.988 108.01 116.749 89.6392 104.11 73.9086C89.3673 55.5597 71.0681 38.215 47.1691 26.2295C23.1277 14.1743 -7.1525 7.98545 -35.5967 12.8312C-55.048 16.1375 -72.4577 24.1533 -88.4222 33.1332C-90.9015 34.5213 -93.3013 35.9808 -95.748 37.3555C-146.241 65.7066 -184.472 94.3353 -207.548 134.667"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M548.488 132.576C544.476 97.3758 518.853 67.8095 478.654 38.2632C468.249 30.6165 456.909 23.2889 443.641 20.187C404.93 11.0276 368.362 32.9903 337.158 47.2664C304.96 61.9963 272.862 78.633 237.609 94.2539C233.396 96.1207 229.18 97.9908 224.932 99.8144C203.274 109.113 178.097 117.759 155.314 112.159C132.17 106.509 119.778 89.0225 106.987 74.0915C92.0581 56.6652 73.7039 40.1998 49.9719 28.8843C26.0547 17.4807 -3.87138 11.7191 -31.9919 16.4717C-51.2641 19.7182 -68.5578 27.4514 -84.447 36.0473C-86.9181 37.3755 -89.3017 38.7852 -91.7463 40.0835C-142.954 67.2942 -180.932 92.7046 -203.154 131.542"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M549.547 130.656C545.69 96.8091 519.648 69.3989 478.736 39.8742C468.347 32.3771 457.131 25.146 444.061 22.0008C405.844 12.6752 369.818 33.2233 338.67 46.8943C306.831 60.8678 274.988 76.9891 239.724 92.3591C235.541 94.1826 231.36 96.0129 227.147 97.8015C205.66 106.909 180.805 115.416 158.261 110.232C135.35 105.011 122.803 88.4077 109.859 74.2762C94.7432 57.7726 76.3361 42.1882 52.773 31.541C28.9779 20.789 -0.589894 15.4529 -28.3888 20.1141C-47.4799 23.3025 -64.6575 30.753 -80.4714 38.9633C-82.9323 40.2316 -85.3016 41.5881 -87.7422 42.8132C-139.688 68.8803 -177.388 91.0774 -198.757 128.42"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M550.606 128.735C546.903 96.2434 520.45 70.9826 478.819 41.4829C468.451 34.1353 457.347 27.0239 444.482 23.8123C406.736 14.3852 371.283 33.4555 340.187 46.5197C308.714 59.7419 277.121 75.3446 241.843 90.4618C237.691 92.2405 233.545 94.0342 229.366 95.7846C208.05 104.703 183.514 113.068 161.215 108.302C138.533 103.508 125.832 87.7871 112.739 74.4552C97.4363 58.8742 78.9742 44.1692 55.5801 34.1919C31.9051 24.0932 2.69756 19.1827 -24.7777 23.7491C-43.6897 26.8793 -60.7309 34.0738 -76.4898 41.8702C-78.9406 43.082 -81.2977 44.3836 -83.7342 45.5356C-136.446 70.4523 -173.842 89.4411 -194.356 125.291"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M551.664 126.815C548.116 95.6765 521.255 72.5635 478.9 43.092C468.552 35.8907 457.568 28.8824 444.901 25.6225C407.645 16.0359 372.75 33.6898 341.699 46.1457C310.596 58.6215 279.249 73.7038 243.958 88.5634C239.836 90.2989 235.724 92.0543 231.578 93.7665C210.433 102.494 186.218 110.719 164.16 106.372C141.71 102.005 128.85 87.167 115.609 74.6364C100.116 59.9763 81.6014 46.1557 58.3783 36.8433C34.8234 27.3979 5.97415 22.9129 -21.1775 27.3863C-39.9103 30.4582 -56.8335 37.3719 -72.5171 44.7809C-74.9577 45.9346 -77.3046 47.1813 -79.733 48.2602C-133.238 72.0166 -170.303 87.8087 -189.962 122.164"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M552.722 124.895C549.327 95.1113 522.069 74.1393 478.984 44.7011C468.658 37.6462 457.79 30.7408 445.323 27.4344C408.559 17.6882 374.226 33.9275 343.213 45.7716C312.489 57.5044 281.383 72.0614 246.075 86.6667C241.983 88.3589 237.906 90.0761 233.794 91.7501C212.823 100.286 188.926 108.372 167.111 104.442C144.892 100.504 131.875 86.547 118.485 74.8176C102.801 61.0784 84.2314 48.1405 61.1833 39.4963C37.7445 30.7059 9.25957 26.6448 -17.5705 31.0234C-36.1241 34.0356 -52.9293 40.6716 -68.5376 47.6916C-70.97 48.7855 -73.3048 49.9773 -75.727 50.9847C-130.049 73.5692 -166.759 86.1746 -185.561 119.037"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M553.781 122.977C550.54 94.5465 522.888 75.714 479.065 46.314C468.764 39.4036 458.012 32.6014 445.742 29.2501C409.469 19.3426 375.708 34.1739 344.726 45.4013C314.386 56.3977 283.514 70.4261 248.19 84.772C244.131 86.421 240.084 88.1 236.009 89.7374C215.208 98.084 191.633 106.03 170.059 102.517C148.071 99.0066 134.893 85.9306 121.357 75.0025C105.48 62.1842 86.8573 50.1323 63.9822 42.1531C40.6594 34.0177 12.5368 30.3805 -13.9696 34.666C-32.3442 37.62 -49.0313 43.9751 -64.5663 50.6078C-66.9885 51.6417 -69.3151 52.7788 -71.7292 53.7163C-126.894 75.1172 -163.221 84.5492 -181.17 115.917"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M554.839 121.057C551.753 93.9794 523.714 77.2813 479.149 47.9228C468.873 41.1538 458.234 34.4596 446.163 31.0618C410.383 20.993 377.196 34.4197 346.24 45.027C316.292 55.2903 285.649 68.7884 250.307 82.875C246.278 84.4808 242.266 86.1215 238.226 87.7207C217.596 95.8761 194.34 103.682 173.01 100.587C151.253 97.5035 137.914 85.3103 124.233 75.1834C108.161 63.2844 89.4831 52.1202 66.7872 44.8059C43.5783 37.3255 15.8221 34.1105 -10.3607 38.3046C-28.5561 41.2004 -45.1251 47.2745 -60.5848 53.5199C-62.9989 54.494 -65.3153 55.5762 -67.7192 56.4423C-123.751 76.6413 -159.673 82.9182 -176.768 112.792"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M555.898 119.138C552.966 93.4147 524.547 78.8428 479.23 49.5325C468.983 42.9048 458.456 36.317 446.583 32.8743C411.293 22.6426 378.688 34.6713 347.753 44.6552C318.201 54.1937 287.782 67.1549 252.422 80.9805C248.424 82.5431 244.446 84.1456 240.439 85.7065C219.98 93.6708 197.052 101.301 175.956 98.6611C154.436 95.9681 140.927 84.6942 127.105 75.3685C110.834 64.3904 92.1049 54.1139 69.586 47.4612C46.4891 40.639 19.0993 37.8447 -6.75983 41.944C-24.7761 44.7816 -41.2291 50.5748 -56.6135 56.4329C-59.0174 57.3488 -61.3277 58.3711 -63.7215 59.1691C-120.64 78.1479 -156.138 81.2864 -172.377 109.667"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M556.956 117.217C554.18 92.8473 525.385 80.3981 479.314 51.141C469.097 44.653 458.678 38.1732 447.004 34.6856C412.207 24.291 380.189 34.9267 349.269 44.2806C320.121 53.0993 289.922 65.5185 254.541 79.0815C250.575 80.6009 246.631 82.1651 242.657 83.6878C222.369 91.4626 199.761 98.9497 178.909 96.7288C157.62 94.4614 143.943 84.0718 129.984 75.5457C113.512 65.4886 94.7308 56.0998 72.3931 50.1104C49.4061 43.9465 22.3867 41.5727 -3.15075 45.5789C-20.9879 48.3566 -37.3249 53.8706 -52.6319 59.3413C-55.0277 60.1974 -57.3319 61.1616 -59.7135 61.893C-117.542 79.6301 -152.592 79.6534 -167.976 106.54"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M558.015 115.297C555.391 92.2823 526.232 81.9476 479.395 52.752C469.209 46.4036 458.9 40.0319 447.423 36.4994C413.119 25.9403 381.693 35.1895 350.781 43.9084C322.04 52.014 292.059 63.888 256.655 77.1867C252.721 78.6645 248.811 80.1888 244.872 81.675C224.755 89.2585 202.468 96.6044 181.857 94.8024C160.797 92.9622 146.954 83.4553 132.856 75.7304C116.181 66.5943 97.3484 58.0964 75.1919 52.767C52.3128 47.263 25.6659 45.3081 0.450046 49.2212C-17.208 51.9408 -33.429 57.1738 -48.6607 62.2573C-51.0463 63.0535 -53.3444 63.9595 -55.7137 64.6228C-114.471 81.0931 -149.052 78.0245 -163.583 103.418"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M559.073 113.377C556.604 91.7151 527.083 83.4915 479.478 54.3608C469.327 48.1487 459.123 41.8867 447.845 38.311C414.031 27.5873 383.205 35.4584 352.296 43.5357C323.97 50.9364 294.198 62.2586 258.772 75.2912C254.87 76.7258 250.991 78.2119 247.089 79.6598C227.143 87.0522 205.175 94.2568 184.808 92.8754C163.979 91.4607 149.966 82.8399 135.732 75.9146C118.852 67.701 99.9701 60.0942 77.9968 55.423C55.2256 50.5823 28.9492 49.043 4.05901 52.8614C-13.4199 55.5228 -29.5249 60.4749 -44.6792 65.1693C-47.0567 65.9057 -49.3507 66.7502 -51.7058 67.3486C-111.407 82.5274 -145.506 76.3934 -159.181 100.293"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M560.132 111.457C557.817 91.1504 527.94 85.028 479.56 55.9704C469.442 49.893 459.343 43.744 448.264 40.1234C414.943 29.2351 384.72 35.7365 353.808 43.1622C325.902 49.8664 296.338 60.63 260.887 73.3933C257.018 74.7864 253.171 76.2309 249.301 77.6423C229.526 84.8451 207.879 91.9084 187.754 90.9442C167.154 89.9568 152.969 82.222 138.602 76.093C121.514 68.8036 102.584 62.0878 80.7957 58.0716C58.1303 53.8942 32.2285 52.7688 7.65986 56.4957C-9.6379 59.0973 -25.6289 63.7684 -40.7079 68.0772C-43.0772 68.7538 -45.3652 69.5367 -47.708 70.072C-108.368 83.9275 -141.97 74.7581 -154.79 97.1647"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M561.19 109.537C559.03 90.5835 528.805 86.559 479.644 57.5795C469.562 51.6367 459.567 45.5991 448.686 41.9337C415.859 30.8775 386.242 36.0191 355.323 42.7865C327.839 48.8024 298.481 59.0008 263.004 71.4949C259.167 72.8464 255.353 74.2511 251.518 75.6242C231.914 82.6359 210.584 89.5595 190.705 89.0142C170.336 88.4557 155.977 81.6069 141.48 76.2741C124.181 69.9107 105.204 64.0859 83.6007 60.7247C61.0391 57.2138 35.5118 56.5007 11.2669 60.1346C-5.85177 62.6779 -21.7267 67.0665 -36.7284 70.9896C-39.0896 71.6063 -41.3734 72.3261 -43.7 72.7982C-105.331 85.3006 -138.422 73.1273 -150.389 94.0395"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M562.248 107.619C560.243 90.0182 529.674 88.0815 479.725 59.1919C469.68 53.382 459.789 47.4575 449.105 43.7488C416.771 32.5264 387.765 36.3165 356.835 42.4173C329.779 47.7534 300.622 57.3816 265.119 69.6014C261.313 70.9113 257.533 72.2761 253.732 73.6126C234.299 80.4332 213.289 87.2171 193.652 87.0891C173.513 86.9578 158.977 80.9983 144.352 76.4602C126.839 71.026 107.819 66.0922 86.4014 63.3826C63.9436 60.5417 38.7928 60.2375 14.8715 63.7766C-2.06797 66.2618 -17.8289 70.3677 -32.7512 73.9052C-35.1022 74.4621 -37.384 75.117 -39.6964 75.5276C-102.307 86.6436 -134.881 71.4981 -145.993 90.9175"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M563.307 105.699C561.454 89.453 530.549 89.5976 479.808 60.8011C469.799 55.1209 460.013 49.3127 449.526 45.5608C417.686 34.1688 389.295 36.6208 358.349 42.0433C331.723 46.7078 302.766 55.7592 267.236 67.7047C263.462 68.9731 259.715 70.298 255.949 71.5962C236.687 78.2273 215.996 84.87 196.604 85.1592C176.692 85.4568 161.982 80.3867 147.228 76.6398C129.501 72.1382 110.435 68.0937 89.2041 66.0341C66.8502 63.8647 42.0739 63.9678 18.4763 67.4138C1.7159 69.8408 -13.929 73.6625 -28.776 76.816C-31.1189 77.313 -33.3946 77.9031 -35.6947 78.2539C-99.2881 87.9486 -131.341 69.8674 -141.598 87.7923"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M564.365 103.779C562.668 88.886 531.433 91.1035 479.89 62.41C469.92 56.8595 460.235 51.1677 449.943 47.3726C418.599 35.8127 390.822 36.9365 359.862 41.6691C333.669 45.672 304.911 54.1383 269.351 65.8078C265.61 67.0346 261.893 68.3196 258.164 69.5797C239.073 76.0195 218.701 82.5242 199.551 83.2307C179.87 83.9555 164.982 79.7814 150.101 76.8225C132.158 73.2551 113.048 70.1016 92.0053 68.687C69.7552 67.1909 45.3555 67.6996 22.0795 71.0525C5.49821 73.4197 -10.0327 76.9588 -24.8004 79.7282C-27.1351 80.1654 -29.4067 80.689 -31.6905 80.9799C-96.2691 89.2151 -127.799 68.2348 -137.201 84.667"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M565.424 101.859C563.881 88.3208 532.321 92.603 479.973 64.0192C470.044 58.5983 460.459 53.0229 450.365 49.1846C419.515 37.4535 392.355 37.264 361.377 41.2951C335.617 44.6464 307.057 52.5209 271.468 63.9095C267.759 65.0964 264.075 66.3398 260.379 67.5616C241.459 73.8103 221.407 80.1771 202.501 81.2991C183.05 82.4545 167.985 79.1747 152.975 77.002C134.818 74.3739 115.664 72.1081 94.8084 71.3385C72.66 70.5206 48.637 71.4299 25.6846 74.6881C9.28244 76.997 -6.13246 80.2519 -20.8248 82.6373C-23.1493 83.0147 -25.4189 83.4702 -27.6885 83.7029C-93.2502 90.442 -124.257 66.6008 -132.804 81.5385"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M566.482 99.9391C565.094 87.7542 533.214 94.0927 480.055 65.6302C470.166 60.3357 460.681 54.8783 450.784 50.9984C420.428 39.0961 393.887 37.6066 362.889 40.9246C337.563 43.6342 309.202 50.9103 273.583 62.0163C269.907 63.1617 266.255 64.3652 262.593 65.5488C243.844 71.608 224.112 77.8351 205.45 79.3744C186.229 80.9586 170.987 78.5765 155.851 77.1868C137.478 75.5011 118.282 74.1247 97.6109 73.9951C75.5664 73.8571 51.9199 75.1637 29.2911 78.3304C13.0681 80.5812 -2.23279 83.5502 -16.8457 85.5533C-19.1621 85.8708 -21.4277 86.2581 -23.681 86.4343C-90.2197 91.6374 -120.712 64.9753 -128.404 78.4185"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M567.541 98.0188C566.307 87.1887 534.114 95.5719 480.138 67.2391C470.29 62.0709 460.906 56.7315 451.205 52.81C421.346 40.7348 395.42 37.9604 364.403 40.5503C339.511 42.6282 311.352 49.2975 275.7 60.1193C272.056 61.2248 268.437 62.3867 264.81 63.5337C246.232 69.4018 226.819 75.4926 208.4 77.4458C189.408 79.4605 173.989 77.9778 158.725 77.3693C140.139 76.6279 120.897 76.1392 100.414 76.6495C78.475 77.1948 55.203 78.897 32.8959 81.9707C16.852 84.1633 1.66506 86.8463 -12.8705 88.467C-15.1788 88.7247 -17.4382 89.0422 -19.6793 89.1619C-87.1849 92.7908 -117.172 63.3442 -124.009 75.2947"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M568.599 96.0992C567.519 86.6222 535.02 97.0434 480.22 68.8486C470.415 63.8034 461.129 58.5853 451.625 54.6223C422.265 42.3743 396.951 38.3298 365.916 40.1767C341.455 41.6329 313.499 47.6871 277.815 58.2213C274.204 59.2869 270.617 60.4073 267.025 61.516C248.619 67.1929 229.526 73.1457 211.349 75.5145C192.588 77.9598 176.996 77.3797 161.599 77.5492C142.804 77.7554 123.515 78.156 103.215 79.2997C81.382 80.5315 58.4826 82.626 36.4991 85.6049C20.6343 87.7377 5.56341 90.1364 -8.89481 91.3732C-11.1949 91.5694 -13.4502 91.817 -15.6771 91.8819C-84.1394 93.8983 -113.632 61.7072 -119.614 72.1633"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M569.657 94.1807C568.731 86.0569 535.931 98.5061 480.303 70.4593C470.54 65.5371 461.354 60.4404 452.046 56.4342C423.182 44.0116 398.477 38.7137 367.429 39.8042C343.396 40.6487 315.648 46.0828 279.931 56.3261C276.353 57.3518 272.799 58.429 269.239 59.5012C251.005 64.9885 232.237 70.8316 214.296 73.5878C195.773 76.4919 180 76.7878 164.471 77.732C145.465 78.8889 126.132 80.1756 106.015 81.9543C84.2902 83.8743 61.7632 86.3595 40.1013 89.2453C24.4157 91.3199 9.45878 93.431 -4.9221 94.2871C-7.21204 94.4234 -9.4633 94.5997 -11.6759 94.6113C-81.0766 94.9753 -110.091 60.078 -115.22 69.0413"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M570.716 92.2609C569.945 85.4918 536.85 99.9575 480.385 72.0702C470.665 67.2694 461.579 62.2957 452.466 58.2479C424.103 45.6507 399.998 39.1144 368.942 39.4319C345.333 39.673 317.798 44.4804 282.047 54.4295C278.503 55.4153 274.977 56.4509 271.454 57.4849C253.391 62.7811 234.945 68.4845 217.246 71.6579C198.953 74.9909 183.011 76.1927 167.346 77.9133C148.137 80.0228 128.755 82.1988 108.819 84.6075C87.2037 87.219 65.0451 90.0915 43.7089 92.8842C28.2045 94.9006 13.3615 96.7242 -0.942008 97.1996C-3.22381 97.2761 -5.46695 97.3792 -7.66937 97.3376C-77.9881 96.0111 -106.546 58.4473 -110.821 65.9162"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M571.775 90.3404C571.158 84.9245 537.772 101.397 480.468 73.6788C470.793 68.9994 461.802 64.147 452.887 60.0594C425.023 47.2843 401.515 39.5279 370.459 39.0575C347.269 38.7067 319.954 42.8792 284.166 52.5323C280.654 53.4798 277.162 54.4723 273.673 55.4697C255.781 60.5747 237.654 66.1385 220.198 69.7308C202.137 73.491 186.026 75.6022 170.224 78.0973C150.811 81.161 131.382 84.2247 111.624 87.2617C90.1227 90.5681 68.3305 93.823 47.316 96.5226C31.9906 98.4808 17.2637 100.017 3.03752 100.112C0.76386 100.127 -1.47111 100.158 -3.66336 100.063C-74.8777 97.0113 -103.002 56.8145 -106.42 62.7906"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M572.833 88.4208C572.371 84.3597 538.699 102.827 480.549 75.2884C470.919 70.727 462.036 65.9876 453.306 61.8717C425.973 48.8806 403.018 39.9588 371.971 38.6855C349.189 37.7496 322.103 41.2837 286.28 50.6377C282.801 51.5453 279.341 52.4962 275.887 53.4553C258.165 58.3708 240.361 63.7934 223.147 67.8029C205.315 71.9903 189.04 75.0124 173.097 78.2789C153.487 82.2968 134.01 86.2515 114.426 89.9153C93.0389 93.9181 71.6111 97.5553 50.9201 100.162C35.7739 102.06 21.163 103.289 7.01218 103.024C4.74869 102.976 2.51981 102.936 0.339777 102.792C-71.7437 97.9792 -99.4612 55.1858 -102.024 59.6675"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M573.892 86.5006C573.582 83.7927 539.634 104.244 480.633 76.8973C471.046 72.4539 462.26 67.8426 453.728 63.6834C426.889 50.5244 404.517 40.4058 373.486 38.3112C351.105 36.8002 324.257 39.691 288.397 48.7391C284.951 49.6085 281.523 50.5161 278.102 51.437C260.552 56.1614 243.067 61.4443 226.095 65.8711C208.493 70.4857 192.057 74.4188 175.97 78.4582C156.165 83.4319 136.638 88.276 117.225 92.5664C95.9583 97.2675 74.8908 101.285 54.5214 103.799C39.5543 105.639 25.0595 106.585 10.986 105.935C8.73062 105.827 6.51189 105.714 4.34 105.516C-68.5862 98.9099 -95.921 53.5515 -97.6309 56.5404"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M574.952 84.5809C574.798 83.2278 540.575 105.651 480.718 78.5084C471.176 74.1814 462.486 69.7014 454.151 65.4974C427.807 52.1721 406.003 40.8716 375.002 37.9392C353.013 35.8596 326.427 38.1404 290.516 46.8443C287.105 47.6788 283.708 48.5399 280.321 49.4226C262.941 53.9558 245.778 59.099 229.048 63.9447C211.679 68.9883 195.09 73.8473 178.848 78.6431C158.86 84.5926 139.286 90.3376 120.032 95.2232C98.8997 100.654 78.1782 105.021 58.1325 107.44C43.3445 109.222 28.9677 109.883 14.9675 108.849C12.7203 108.681 10.5117 108.492 8.348 108.244C-65.3883 99.8129 -92.3751 51.9228 -93.23 53.4155"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M576.011 82.6608C576.011 82.6608 541.517 107.044 480.8 80.1174C420.082 53.191 396.249 20.6358 292.631 44.9475C189.013 69.2591 98.4801 119.872 18.9426 111.76C-60.5949 103.648 -88.8335 50.2902 -88.8335 50.2902"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M622.143 65.6831C615.937 52.0669 597.766 43.9797 580.02 42.9258C562.275 41.8719 544.816 46.5812 528.267 51.9157C494.04 62.9452 461.23 76.9188 426.311 86.3891C391.392 95.8594 353.301 100.664 317.804 92.7542C295.979 87.8919 275.929 78.4116 253.865 74.3405C209.621 66.1752 164.4 80.5776 119.342 84.8365C85.2511 88.0581 72.4477 74.673 53.4585 54.8996C35.0249 35.7046 7.7552 22.3095 -21.6477 18.0058C-51.0507 13.702 -82.3181 18.5311 -107.768 31.3044"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M622.786 63.7668C615.886 50.9984 597.324 43.4032 579.293 42.8164C561.234 42.2446 543.424 47.2266 526.421 52.669C492.029 63.7053 458.854 77.343 423.799 86.1251C388.874 94.9471 351.078 98.8786 315.559 90.9692C293.809 86.1251 273.741 76.9574 251.739 73.0625C207.648 65.2512 162.635 79.4326 117.758 83.6549C83.8668 86.8449 70.5526 73.8904 51.2926 54.5824C32.7389 35.8662 5.69309 22.5875 -23.4513 18.824C-52.5347 15.0239 -83.2607 20.2253 -108.477 32.9937"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M623.431 61.8482C615.839 49.9293 596.886 42.8228 578.571 42.7031C560.196 42.6134 542.035 47.8663 524.579 53.4202C490.02 64.463 456.46 77.6985 421.293 85.8573C386.339 93.9661 348.859 97.088 313.319 89.1786C291.643 84.3545 271.559 75.4959 249.618 71.779C205.682 64.3217 160.876 78.282 116.178 82.4694C82.4865 85.6279 68.5921 73.1537 49.1306 54.2596C30.3917 36.0671 3.63499 22.8599 -25.253 19.6349C-54.0188 16.3385 -84.2033 21.9123 -109.183 34.6757"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M624.074 59.93C615.79 48.8589 596.446 42.2444 577.844 42.5919C559.156 42.9842 540.643 48.5098 522.732 54.1717C488.009 65.2212 454.077 78.0893 418.781 85.5897C383.815 93.0204 346.637 95.2994 311.074 87.3884C289.473 82.5826 269.373 74.0365 247.493 70.4974C203.709 63.3943 159.111 77.1318 114.595 81.286C81.1024 84.4128 66.6666 72.3942 46.9629 53.9406C28.0733 36.2501 1.5608 23.1974 -27.0605 20.4513C-55.5149 17.72 -85.1519 23.6064 -109.896 36.3648"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M624.719 58.0113C615.743 47.7897 596.006 41.664 577.119 42.4802C558.118 43.3546 539.252 49.1511 520.888 54.9244C485.997 65.9806 451.697 78.4846 416.273 85.3235C381.295 92.0775 344.418 93.5104 308.833 85.5994C287.305 80.8119 267.188 72.5767 245.372 69.2155C201.741 62.4664 157.35 75.9828 113.015 80.1004C79.7221 83.1957 64.7468 71.6308 44.8009 53.6195C25.7668 36.4293 -0.497296 23.4913 -28.8621 21.2638C-56.9989 19.0546 -86.0925 25.295 -110.602 38.0484"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M625.363 56.0954C615.694 46.7215 595.567 41.0878 576.393 42.3711C557.076 43.7276 537.861 49.7968 519.04 55.6798C483.983 66.7426 449.316 78.8826 413.76 85.0598C378.773 91.139 342.191 91.7258 306.586 83.8131C285.134 79.0455 264.999 71.1212 243.245 67.9362C199.769 61.5412 155.584 74.8348 111.43 78.9192C78.3364 81.9829 62.8237 70.8735 42.6335 53.3026C23.455 36.6128 -2.56089 23.7879 -30.6672 22.0824C-58.4845 20.3951 -87.0386 26.9896 -111.312 39.7397"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M626.008 54.1766C615.647 45.6522 595.123 40.4723 575.67 42.2593C556.033 44.063 536.472 50.4397 517.198 56.4307C481.975 67.5002 446.942 79.2778 411.254 84.7934C376.259 90.201 339.974 89.9367 304.349 82.0256C282.97 77.2764 262.818 69.6629 241.126 66.6557C197.802 60.6148 153.825 73.6874 109.852 77.7352C76.958 80.7673 60.9121 70.1117 40.4735 52.983C21.1545 36.7936 -4.61503 24.0801 -32.4669 22.8982C-59.9646 21.7312 -87.9772 28.6831 -112.017 41.4265"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M626.651 52.2584C615.598 44.5818 594.682 39.8907 574.943 42.1481C554.991 44.4305 535.08 51.0815 515.352 57.1839C479.962 68.26 444.565 79.6786 408.742 84.5276C373.743 89.2636 337.749 88.1498 302.104 80.2371C280.8 75.5061 260.63 68.2052 239.001 65.3742C195.83 59.6874 152.06 72.5389 108.268 76.5517C75.5739 79.5522 58.9987 69.3505 38.3057 52.6623C18.8504 36.9716 -6.67698 24.3711 -34.2744 23.7112C-61.4505 23.0629 -88.9258 30.3721 -112.729 43.1122"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M627.296 50.34C615.552 43.5128 594.24 39.3087 574.218 42.0366C553.949 44.7994 533.675 51.6898 513.507 57.9351C477.925 68.9564 442.193 80.0791 406.234 84.2598C371.231 88.3292 335.531 86.361 299.862 78.4467C278.632 73.734 258.446 66.7438 236.88 64.0924C193.861 58.758 150.299 71.3884 106.687 75.3664C74.1917 78.337 57.0873 68.5874 36.1419 52.3414C16.5521 37.1477 -8.73294 24.6586 -36.0759 24.5256C-62.9304 24.3943 -89.8663 32.0626 -113.438 44.7977"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M627.942 48.4236C615.503 42.4442 593.801 38.7288 573.494 41.9272C552.909 45.1704 532.283 52.3317 511.664 58.6901C475.914 69.7147 439.824 80.4866 403.725 83.9958C368.72 87.3986 333.308 84.5743 297.62 76.6599C276.465 71.9672 256.262 65.2879 234.755 62.8127C191.891 57.8324 148.535 70.2417 105.103 74.1847C72.8079 77.1237 55.1784 67.8263 33.9765 52.0242C14.2545 37.3275 -10.7904 24.9498 -37.881 25.3421C-64.4118 25.7261 -90.8124 33.7568 -114.147 46.4853"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M628.585 46.5049C615.454 41.3749 593.359 38.1466 572.77 41.8154C551.869 45.539 530.893 52.9713 509.819 59.4428C473.903 70.4707 437.455 80.8935 401.217 83.7295C366.212 86.4706 331.09 82.7869 295.379 74.8726C274.297 70.1981 254.078 63.8297 232.634 61.5323C189.923 56.9061 146.774 69.0926 103.524 73.0024C71.4277 75.9098 53.2771 67.0629 31.8126 51.7063C11.9624 37.5033 -12.8464 25.2386 -39.6846 26.1596C-65.8918 27.0572 -91.755 35.4503 -114.856 48.1755"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M629.231 44.5868C615.407 40.3046 592.919 37.5668 572.045 41.7043C550.827 45.9083 529.501 53.6133 507.975 60.1944C471.892 71.2273 435.086 81.3011 398.707 83.4637C363.703 85.5433 328.869 80.9985 293.136 73.0842C272.129 68.428 251.892 62.3704 230.511 60.2509C187.953 55.9788 145.012 67.9442 101.942 71.8174C70.0458 74.6933 51.3762 66.2952 29.6492 51.3857C9.67267 37.6765 -14.9 25.5232 -41.4858 26.9727C-67.3693 28.384 -92.6971 37.1395 -115.562 49.8597"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M629.873 42.668C615.358 39.2353 592.477 36.9878 571.318 41.5925C549.784 46.2786 528.108 54.2545 506.129 60.947C469.878 71.9849 432.716 81.7129 396.195 83.1973C361.19 84.6203 326.644 79.2111 290.89 71.295C269.957 66.6588 249.703 60.9121 228.385 58.9705C185.98 55.0524 143.246 66.7951 100.358 70.6351C68.6612 73.4793 49.4765 65.5284 27.4828 51.0661C7.38215 37.8489 -16.9564 25.807 -43.2918 27.7885C-68.8497 29.7101 -93.6422 38.833 -116.273 51.5482"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M630.519 40.7518C615.312 38.1685 592.038 36.4098 570.594 41.4832C548.745 46.6514 526.719 54.8982 504.285 61.7005C467.87 72.745 430.349 82.1289 393.688 82.9318C358.685 83.6981 324.426 77.4228 288.652 69.5068C267.794 64.8888 247.522 59.453 226.265 57.6893C184.014 54.1252 141.486 65.6469 98.7793 69.4503C67.2818 72.2629 47.5822 64.7575 25.3219 50.7457C5.10112 38.0189 -19.0075 26.0883 -45.0925 28.6018C-70.3247 31.0338 -94.5838 40.5224 -116.979 53.2326"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M631.162 38.8333C615.263 37.0978 591.596 35.8311 569.869 41.3717C547.704 47.0236 525.328 55.5398 502.441 62.4534C465.858 73.5046 427.984 82.546 391.178 82.6657C356.177 82.7804 322.202 75.6357 286.408 67.718C265.623 63.1183 245.335 57.995 224.142 56.4075C182.043 53.1975 139.723 64.4981 97.1972 68.2666C65.8992 71.0476 45.6907 63.9861 23.1555 50.4264C2.81674 38.1883 -21.0618 26.3691 -46.8985 29.4179C-71.805 32.3569 -95.5309 42.2145 -117.689 54.9197"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M631.807 36.9152C615.216 36.0291 591.156 35.2528 569.144 41.2588C546.664 47.3928 523.938 56.1799 500.597 63.2049C463.849 74.2644 425.616 82.9651 388.67 82.3999C353.671 81.8646 319.984 73.8489 284.167 65.9312C263.458 61.3515 243.154 56.5373 222.021 55.1277C180.075 52.2718 137.963 63.3496 95.6178 67.0832C64.5193 69.8327 43.8019 63.2133 20.994 50.1074C0.541227 38.3547 -23.1134 26.6486 -48.6977 30.2343C-73.2806 33.6786 -96.4691 43.9086 -118.394 56.6088"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M632.451 34.9963C615.167 34.9581 590.715 34.6738 568.418 41.1469C545.622 47.7647 522.546 56.8227 498.75 63.9558C461.838 75.0219 423.249 83.3851 386.158 82.1317C351.16 80.9482 317.761 72.058 281.922 64.1403C261.286 59.5789 240.965 55.0773 219.896 53.8455C178.105 51.342 136.198 62.2004 94.0342 65.8991C63.1352 68.617 41.913 62.4364 18.8283 49.7877C-1.73849 38.5188 -25.1693 26.9257 -50.5032 31.0483C-74.7604 34.9963 -97.4156 45.5987 -119.106 58.2939"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M633.096 33.08C615.118 33.8913 590.277 34.0991 567.693 41.0376C544.584 48.1391 521.155 57.4681 496.906 64.7109C459.829 75.7854 420.882 83.8128 383.65 81.8678C348.654 80.0393 315.54 70.2731 279.681 62.3537C259.12 57.8106 238.781 53.6198 217.773 52.5659C176.134 50.4165 134.435 61.0521 92.4506 64.7159C61.7531 67.4022 40.0261 61.6572 16.6605 49.4673C-4.01623 38.6788 -27.2271 27.1987 -52.3107 31.8632C-76.2422 36.3133 -98.3621 47.2897 -119.818 59.9816"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M633.739 31.1616C615.069 32.8206 589.835 33.5205 566.966 40.9262C543.542 48.5114 519.763 58.1113 495.06 65.4638C457.818 76.5483 418.513 84.2416 381.139 81.6018C346.144 79.1299 313.317 68.4843 277.436 60.5649C256.948 56.0417 236.593 52.1619 215.648 51.2842C174.162 49.4888 132.67 59.9033 90.8669 63.5322C60.3688 66.187 38.1411 60.8758 14.4946 49.148C-6.29205 38.8383 -29.2831 27.4712 -54.1143 32.6777C-77.7221 37.6281 -99.3067 48.9818 -120.527 61.6671"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M634.384 29.2432C615.022 31.7516 589.397 32.9435 566.243 40.8147C542.505 48.8853 518.395 58.7961 493.217 66.2151C455.837 77.3694 416.147 84.6703 378.633 81.334C343.638 78.2221 311.098 66.6955 275.196 58.7762C254.784 54.2712 234.411 50.7022 213.528 50.0024C172.195 48.5611 130.911 58.7546 89.289 62.3485C58.9905 64.9717 36.264 60.0911 12.3346 48.8288C-8.5579 38.9961 -31.3332 27.7421 -55.914 33.4937C-79.1982 38.9412 -100.245 50.674 -121.231 63.3542"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M635.03 27.3247C614.976 30.681 588.978 32.4015 565.519 40.7032C541.486 49.2941 517.005 59.4376 491.374 66.968C453.829 78.1289 413.778 85.104 376.123 81.0696C341.129 77.3193 308.878 64.9084 272.953 56.989C252.615 52.5024 232.225 49.2459 211.404 48.7239C170.225 47.6367 129.147 57.6074 87.7058 61.1665C57.6067 63.758 34.3836 59.3047 10.1692 48.5111C-10.8291 39.1522 -33.3907 28.0129 -57.7191 34.3098C-80.6796 40.2543 -101.191 52.3661 -121.941 65.043"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M635.673 25.4082C614.927 29.6139 588.538 31.8248 564.792 40.5936C540.443 49.6666 515.612 60.0828 489.527 67.7212C451.815 78.8888 411.406 85.5397 373.613 80.8038C338.617 76.4185 306.655 63.1215 270.712 55.2005C250.449 50.7322 230.041 47.7865 209.283 47.4424C168.257 46.7093 127.386 56.4589 86.1261 59.983C56.2265 62.543 32.5087 58.5119 8.00526 48.1921C-13.0969 39.302 -35.4488 28.2807 -59.5207 35.1262C-82.1596 41.5644 -102.132 54.0585 -122.648 66.7305"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M636.318 23.4897C614.88 28.5432 588.099 31.2445 564.068 40.4821C539.405 50.0389 514.222 60.7243 487.683 68.4741C449.806 79.6483 409.035 85.9768 371.103 80.5377C336.105 75.5191 304.434 61.3344 268.469 53.4117C248.279 48.9633 227.857 46.3285 207.159 46.1606C166.286 45.7816 125.623 55.3085 84.5444 58.7977C54.8443 61.3261 30.632 57.7155 5.84149 47.8695C-15.3644 39.4481 -37.5088 28.5416 -61.3242 35.939C-83.6456 42.8709 -103.079 55.749 -123.358 68.4159"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M636.961 21.5718C614.831 27.4747 587.659 30.6664 563.343 40.3711C538.365 50.4099 512.832 61.368 485.839 69.2275C447.795 80.4084 406.662 86.4177 368.596 80.2721C333.593 74.6218 302.216 59.5461 266.228 51.6234C246.113 47.1933 225.672 44.8694 205.039 44.8793C164.318 44.8544 123.862 54.1601 82.965 57.6145C53.4644 60.1113 28.7594 56.9163 3.6799 47.5507C-17.6278 39.5931 -39.5665 28.8062 -63.1255 36.7539C-85.1253 44.1762 -104.019 57.4399 -124.062 70.1019"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M637.607 19.6533C614.785 26.4041 587.22 30.0861 562.619 40.2596C537.327 50.7805 511.442 62.0095 483.995 69.9788C445.786 81.1646 404.289 86.8598 366.086 80.0043C331.077 73.724 299.993 57.7573 263.985 49.8346C243.943 45.4228 223.487 43.4097 202.914 43.5976C162.348 43.925 122.098 53.0113 81.3815 56.4291C52.0804 58.8943 26.8828 56.1116 1.51223 47.2298C-19.8972 39.7326 -41.6324 29.0654 -64.9329 37.5683C-86.6172 45.4793 -104.965 59.1304 -124.777 71.789"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M638.25 17.7368C614.734 25.337 586.78 29.5094 561.892 40.15C536.287 51.153 510.049 62.6547 482.149 70.7336C443.773 81.9261 401.911 87.3054 363.576 79.7418C328.561 72.8331 297.772 55.9721 261.742 48.0494C241.775 43.6576 221.3 41.9553 200.79 42.321C160.377 43.0026 120.335 51.8662 79.7997 55.2507C50.698 57.6843 25.0099 55.3105 -0.651765 46.9157C-22.163 39.8774 -43.6967 29.3316 -66.7345 38.388C-88.1033 46.7877 -105.908 60.8278 -125.483 73.4798"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M638.895 15.8184C614.687 24.2663 586.342 28.9292 561.167 40.0385C535.247 51.5236 508.659 63.2962 480.304 71.4849C441.764 82.684 399.533 87.7508 361.066 79.474C326.043 71.9387 295.549 54.1833 259.498 46.259C239.605 41.8854 219.114 40.494 198.667 41.0376C158.407 42.0732 118.572 50.7157 78.216 54.0653C49.3138 56.4674 23.1331 54.4975 -2.81758 46.5931C-24.4306 40.0103 -45.7648 29.5875 -68.5401 39.2007C-89.5954 48.0876 -106.852 62.5166 -126.194 75.1636"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M639.538 13.8999C614.638 23.1973 585.9 28.3506 560.442 39.9254C534.209 51.8925 507.269 63.9378 478.458 72.2361C439.751 83.4419 397.152 88.1962 358.554 79.2063C323.521 71.0459 293.326 52.3929 257.253 44.4685C237.435 40.1132 216.926 39.0344 196.542 39.7542C156.436 41.1439 116.807 49.5636 76.6323 52.8783C47.9296 55.2504 21.2583 53.6795 -4.98346 46.2705C-26.7003 40.1398 -47.835 29.8417 -70.3457 40.0118C-91.0895 49.3857 -107.799 64.2037 -126.904 76.8474"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M640.184 11.9814C614.591 22.1267 585.463 27.7703 559.718 39.8139C533.169 52.2631 505.879 64.581 476.614 72.989C437.742 84.2015 394.771 88.6466 356.047 78.9402C321.002 70.1564 291.108 50.6057 255.012 42.6814C235.268 38.346 214.744 37.5764 194.419 38.474C154.466 40.2178 115.047 48.4164 75.0511 51.6962C46.5479 54.0368 19.384 52.8632 -7.14884 45.9529C-28.9675 40.271 -49.9067 30.0992 -72.1487 40.8296C-92.5832 50.6889 -108.741 65.8992 -127.612 78.5362"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M640.829 10.0649C614.544 21.0596 585.025 27.1936 558.993 39.7043C532.131 52.6373 504.488 65.2244 474.77 73.7422C435.731 84.9613 392.36 89.1604 353.537 78.6761C318.455 69.3254 288.885 48.8206 252.771 40.8946C233.102 36.5775 212.56 36.1203 192.298 37.1959C152.498 39.2937 113.286 47.2713 73.4713 50.5145C45.1676 52.8235 17.5111 52.0405 -9.3108 45.6355C-31.2332 40.3992 -51.9791 30.357 -73.9504 41.6476C-94.0775 51.9906 -109.684 67.5933 -128.319 80.227"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M641.472 8.14648C614.495 19.9906 584.583 26.6133 558.266 39.5928C531.088 53.0078 503.096 65.8676 472.924 74.4951C433.72 85.7209 389.985 89.5825 351.027 78.4099C315.939 68.411 286.664 47.0318 250.528 39.1058C230.932 34.807 210.373 34.6607 190.175 35.9141C150.527 38.366 111.523 46.1208 71.8896 49.3308C43.7853 51.6082 15.6342 51.2142 -11.4747 45.3162C-33.5029 40.5237 -54.0738 30.5896 -75.754 42.462C-95.5941 53.2688 -110.626 69.2837 -129.027 81.9125"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
      <path
        d="M642.117 6.22852C614.449 18.9204 584.146 26.0352 557.544 39.4818C530.052 53.3789 501.708 66.5097 471.082 75.2486C431.711 86.4809 387.614 90.0067 348.52 78.1443C313.425 67.4954 284.444 45.2451 248.287 37.3175C228.767 33.0386 208.19 33.2032 188.054 34.6328C148.561 37.4388 109.763 44.9725 70.3104 48.1459C42.4056 50.3917 13.7599 50.3817 -13.638 44.9941C-35.7722 40.6421 -56.1334 30.8626 -77.5571 43.2753C-97.0777 54.5858 -111.57 70.9747 -129.735 83.5968"
        stroke={colors.primary}
        stroke-opacity="0.25"
        stroke-width="0.5"
        stroke-miterlimit="10"
      />
    </svg>
  );
}
